<div class="min-h-screen pb-12 bg-gray-50 text-slate-800">
  <main class="w-full px-4 sm:px-6 lg:px-8 py-8">

    <!-- Breadcrumbs -->
    <nav class="flex mb-4" aria-label="Breadcrumb">
      <ol class="flex items-center space-x-2 text-sm text-gray-500">
        <li><a [routerLink]="['/dashboard']" class="hover:text-indigo-600">Dashboard</a></li>
        <li>
          <svg class="w-3 h-3 inline text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </li>
        <li><a [routerLink]="['/dashboard/enrollments']" class="hover:text-indigo-600">Inscripciones</a></li>
        <li>
          <svg class="w-3 h-3 inline text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </li>
        <li><span class="text-gray-600">Corporativa</span></li>
        <li>
          <svg class="w-3 h-3 inline text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </li>
        <li class="font-medium text-gray-800">#{{ agreementId }}</li>
      </ol>
    </nav>

  <!-- Header con estado y acciones -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
    <div>
      <div class="flex items-center gap-4 flex-wrap">
        <h1 class="text-3xl font-bold text-gray-900 tracking-tight">Detalle de Inscripción Empresarial</h1>
        <span class="px-3 py-1 text-sm font-medium rounded-full border" [ngClass]="getEnrollmentStatusClass(enrollmentStatus)">
          {{ enrollmentStatusLabel }}
        </span>
      <!-- Selector de Estado -->
      <div *ngIf="canUpdateEnrollmentStatus && !isEnrollmentCancelled" class="flex items-center gap-2">
        <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        <p-dropdown [options]="enrollmentStatusOptions" [(ngModel)]="selectedEnrollmentStatus" optionLabel="label"
          optionValue="value" (onChange)="onStatusChange($event.value)" placeholder="Selecciona estado"
          styleClass="w-auto min-w-[150px]" appendTo="body">
        </p-dropdown>
      </div>
      </div>
      <p class="mt-1 text-sm text-gray-500">Gesti&oacute;n financiera y seguimiento de pagos del acuerdo corporativo.</p>
    </div>

    <!-- Botones de acciones de cartera -->
    <div class="flex flex-wrap gap-2">
      <button *ngIf="isEnrollmentActive && canWithdrawCorporateEnrollments" (click)="goToWithdrawal()"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6" />
        </svg>
        Procesar Retiro
      </button>

      <button *ngIf="isEnrollmentActive && canDeferCorporateEnrollments" (click)="goToDeferral()"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-amber-600 rounded-lg hover:bg-amber-700 transition-colors">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Procesar Aplazamiento
      </button>

      <button *ngIf="isEnrollmentWithdrawn && canReverseCorporateWithdrawals" (click)="goToReversal()"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
        </svg>
        Revertir Retiro
      </button>

      <button *ngIf="!isEnrollmentCancelled" (click)="goToAddParticipants()"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
        </svg>
        Agregar Participantes
      </button>

      <!-- Botón Anular -->
      <button *ngIf="!isEnrollmentCancelled && enrollmentStatus !== 'Reversed' && enrollmentStatus !== 'Withdrawn'"
        (click)="openCancellationModal()"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-red-700 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 transition-colors shadow-sm">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
        </svg>
        Anular
      </button>
    </div>
  </div>

  <!-- 🆕 Banner "Necesita atención" — alguna versión del plan corporativo
       tiene TotalAmount distinto a la suma de cuotas activas. -->
  <div *ngIf="details?.needsAttention"
    class="mb-4 flex gap-3 items-start rounded-lg border-2 border-yellow-300 bg-yellow-50 px-4 py-3">
    <svg class="h-6 w-6 flex-shrink-0 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
    <div class="flex-1">
      <h3 class="text-yellow-900 font-semibold">Esta inscripción corporativa necesita atención</h3>
      <p class="text-yellow-800 text-sm mt-1">
        El total asignado en cuotas no coincide con el total registrado de una o más versiones del plan.
      </p>
      <p *ngIf="details?.needsAttentionReason" class="text-yellow-900 text-xs mt-2 font-mono">
        {{ details.needsAttentionReason }}
      </p>
    </div>
  </div>

  <!-- Ficha de Información del Acuerdo Corporativo -->
  <div class="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 px-5 py-4" *ngIf="details">
    <div class="flex flex-wrap items-center gap-x-8 gap-y-3">
      <!-- Número de acuerdo prominente -->
      <div class="flex items-center gap-3">
        <span class="inline-flex items-center px-3 py-1.5 bg-indigo-100 text-indigo-800 rounded-lg text-lg font-bold tracking-tight">
          #{{ agreementId }}
        </span>
        <span class="text-sm font-medium text-gray-500">Acuerdo Corporativo</span>
        <a [routerLink]="['/dashboard/enrollments/payment-plans/history', agreementId]"
          [queryParams]="{ type: 'corporate' }" target="_blank"
          class="inline-flex items-center gap-1 text-sm text-gray-600 border border-gray-200 px-2.5 py-1 rounded hover:bg-gray-50 hover:text-gray-800 transition">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Ver historial
        </a>
      </div>

      <!-- Separador visual -->
      <div class="hidden md:block w-px h-8 bg-gray-200"></div>

      <!-- Fecha de Creación -->
      <div class="flex items-center gap-2" *ngIf="details.createdAt">
        <div class="p-1.5 bg-gray-100 rounded-md">
          <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <p class="text-xs text-gray-500 leading-none mb-0.5">Fecha de Creaci&oacute;n</p>
          <p class="text-sm font-semibold text-gray-800">{{ details.createdAt | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
      </div>

      <!-- Registrado por -->
      <div class="flex items-center gap-2" *ngIf="details.createdBy">
        <div class="p-1.5 bg-gray-100 rounded-md">
          <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div>
          <p class="text-xs text-gray-500 leading-none mb-0.5">Registrado por</p>
          <p class="text-sm font-semibold text-gray-800">{{ details.createdBy }}</p>
        </div>
      </div>

      <!-- Separador visual -->
      <div class="hidden md:block w-px h-8 bg-gray-200" *ngIf="details.updatedAt"></div>

      <!-- Última modificación -->
      <div class="flex items-center gap-2" *ngIf="details.updatedAt">
        <div class="p-1.5 bg-blue-50 rounded-md">
          <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </div>
        <div>
          <p class="text-xs text-gray-500 leading-none mb-0.5">&Uacute;ltima modificaci&oacute;n</p>
          <p class="text-sm font-semibold text-gray-800">{{ details.updatedAt | date:'dd/MM/yyyy HH:mm' }}
            <span *ngIf="details.updatedBy" class="text-xs font-normal text-gray-500">por {{ details.updatedBy }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="details; else loadingTpl">

    <!-- 🆕 Historial de Movimientos de Cartera (Timeline) -->
    <div *ngIf="hasMovementHistory()" class="mb-6">
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-200">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-bold text-blue-800 flex items-center gap-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Historial de Movimientos de Cartera Corporativa
          </h3>
          <span class="px-2 py-1 text-xs font-medium bg-blue-200 text-blue-800 rounded-full">
            {{ movementHistory.length }} movimiento(s)
          </span>
        </div>

        <!-- Timeline de movimientos -->
        <div class="relative">
          <!-- Línea vertical del timeline -->
          <div class="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-300"></div>

          <!-- Eventos del timeline -->
          <div class="space-y-4">
            <div *ngFor="let movement of movementHistory; let i = index; let last = last" class="relative pl-10">
              <!-- Punto del timeline -->
              <div
                class="absolute left-2 w-5 h-5 rounded-full border-2 border-white shadow-md flex items-center justify-center"
                [ngClass]="getTimelineDotClass(movement.movementType)">
                <span class="text-white text-xs">{{ i + 1 }}</span>
              </div>

              <!-- Contenido del evento -->
              <div class="p-4 rounded-lg border-l-4 shadow-sm" [ngClass]="getMovementClass(movement.movementType)">
                <div class="flex flex-wrap items-start justify-between gap-2">
                  <div class="flex-1">
                    <div class="flex items-center gap-2 mb-1">
                      <span class="text-lg">{{ getMovementIcon(movement.movementType) }}</span>
                      <span class="font-bold">{{ movement.movementTypeDescription }}</span>
                      <span *ngIf="movement.isReverted"
                        class="px-2 py-0.5 text-xs bg-gray-200 text-gray-700 rounded-full">
                        Revertido
                      </span>
                    </div>
                    <p class="text-sm opacity-80">
                      {{ movement.movementDate | date:'medium' }}
                    </p>
                  </div>
                  <div class="text-right">
                    <p class="text-xs opacity-70">Monto afectado</p>
                    <p class="font-bold">{{ formatCurrencyValue(movement.totalAffectedAmount) }}</p>
                    <p class="text-xs opacity-70">{{ movement.affectedInstallmentsCount }} cuota(s)</p>
                  </div>
                </div>

                <!-- Razón del movimiento -->
                <div *ngIf="movement.reason" class="mt-3 p-2 bg-white/50 rounded">
                  <p class="text-xs font-medium opacity-70">📝 Razón:</p>
                  <p class="text-sm">{{ movement.reason }}</p>
                </div>

                <!-- Notas adicionales -->
                <div *ngIf="movement.notes" class="mt-2 p-2 bg-white/50 rounded">
                  <p class="text-xs font-medium opacity-70">📋 Notas:</p>
                  <p class="text-sm">{{ movement.notes }}</p>
                </div>

                <!-- Usuario que realizó el movimiento -->
                <div class="mt-2 flex items-center gap-2 text-xs opacity-60">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span>Realizado por: {{ movement.performedBy }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Banner de Estado Actual (solo si está retirada o aplazada Y no tiene historial visible) -->
    <div *ngIf="isEnrollmentWithdrawnOrDeferred() && !hasMovementHistory()" class="mb-6 p-4 rounded-xl border-l-4"
      [ngClass]="{
           'bg-red-50 border-red-500': isEnrollmentWithdrawn,
           'bg-orange-50 border-orange-500': isEnrollmentDeferred
         }">
      <div class="flex items-start gap-4">
        <div class="flex-shrink-0">
          <svg *ngIf="isEnrollmentWithdrawn" class="w-8 h-8 text-red-500" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <svg *ngIf="isEnrollmentDeferred" class="w-8 h-8 text-orange-500" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-bold" [ngClass]="{
                'text-red-800': isEnrollmentWithdrawn,
                'text-orange-800': isEnrollmentDeferred
              }">
            Acuerdo Corporativo {{ enrollmentStatusLabel }}
          </h3>
          <p class="text-sm mt-1" [ngClass]="{
               'text-red-700': isEnrollmentWithdrawn,
               'text-orange-700': isEnrollmentDeferred
             }">
            Este acuerdo corporativo tiene cartera castigada y no genera cobros activos.
          </p>
        </div>
        <div class="flex-shrink-0">
          <span class="px-3 py-1 text-sm font-bold rounded-full" [ngClass]="{
                  'bg-red-100 text-red-800': isEnrollmentWithdrawn,
                  'bg-orange-100 text-orange-800': isEnrollmentDeferred
                }">
            {{ enrollmentStatusLabel }}
          </span>
        </div>
      </div>
    </div>

    <!-- RESUMEN EJECUTIVO -->
    <section class="mb-8">
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          Resumen Ejecutivo
        </h2>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          <div class="bg-white p-4 rounded-lg border border-blue-200 text-center">
            <p class="text-2xl font-bold text-blue-600">{{ details.participantEnrollments?.length || 0 }}</p>
            <p class="text-sm text-gray-600">Participantes</p>
          </div>
          <div class="bg-white p-4 rounded-lg border border-green-200 text-center">
            <p class="text-2xl font-bold text-green-600">{{ formatCurrencyValue(getTotalEnrollmentValue()) }}</p>
            <p class="text-sm text-gray-600">Valor Total</p>
            <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">≈ {{
              calculateCOPEquivalent(getTotalEnrollmentValue()) }}</p>
          </div>
          <div class="bg-white p-4 rounded-lg border border-emerald-200 text-center">
            <p class="text-2xl font-bold text-emerald-600">{{ formatCurrencyValue(getTotalPaidValue()) }}</p>
            <p class="text-sm text-gray-600">Total Pagado</p>
            <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">≈ {{
              calculateCOPEquivalent(getTotalPaidValue()) }}</p>
          </div>
          <div class="bg-white p-4 rounded-lg border border-orange-200 text-center">
            <p class="text-2xl font-bold text-orange-600">{{ formatCurrencyValue(getTotalPendingValue()) }}</p>
            <p class="text-sm text-gray-600">Total Pendiente</p>
            <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">≈ {{
              calculateCOPEquivalent(getTotalPendingValue()) }}</p>
          </div>
          <div class="bg-white p-4 rounded-lg border border-rose-200 text-center">
            <p class="text-2xl font-bold text-rose-700">{{ formatCurrencyValue(getTotalCastigadoValue()) }}</p>
            <p class="text-sm text-gray-600">Cartera Castigada</p>
            <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">≈ {{
              calculateCOPEquivalent(getTotalCastigadoValue()) }}</p>
          </div>
          <div class="bg-white p-4 rounded-lg border border-purple-200 text-center">
            <p class="text-2xl font-bold text-purple-600">{{ getPaymentCompletionPercentage() | number:'1.0-1' }}%</p>
            <p class="text-sm text-gray-600">Completado</p>
          </div>
        </div>

        <!-- Barra de progreso -->
        <div class="mt-4">
          <div class="flex justify-between text-sm text-gray-600 mb-1">
            <span>Progreso de pagos</span>
            <span>{{ getPaymentCompletionPercentage() | number:'1.0-1' }}%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-3">
            <div class="bg-gradient-to-r from-green-400 to-green-600 h-3 rounded-full transition-all duration-300"
              [style.width.%]="getPaymentCompletionPercentage()"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- INFORMACIÓN DE EMPRESA Y PROYECTO -->
    <section class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div class="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-200">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            Empresa
          </h3>
          <a [routerLink]="['/dashboard/companies/view-company', details.company?.id]" target="_blank"
            class="inline-flex items-center gap-2 text-sm bg-white text-blue-600 border border-blue-100 px-3 py-1.5 rounded-md shadow-sm hover:bg-blue-50 transition">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
            </svg>
            Ver empresa
          </a>
        </div>
        <ul class="text-gray-700 text-sm space-y-2">
          <li><strong>Nombre:</strong> {{ details.company?.name }}</li>
          <li><strong>NIT:</strong> {{ details.company?.documentId }}</li>
          <li><strong>Correo:</strong> {{ details.company?.email }}</li>
          <li><strong>Teléfono:</strong> {{ details.company?.phone || 'N/A' }}</li>
        </ul>
      </div>

      <div class="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-200">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
            </svg>
            Proyecto
          </h3>
          <a [routerLink]="['/projects/view-project', details.project?.id]" target="_blank"
            class="inline-flex items-center gap-2 text-sm bg-white text-blue-600 border border-blue-100 px-3 py-1.5 rounded-md shadow-sm hover:bg-blue-50 transition">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
            </svg>
            Ver proyecto
          </a>
        </div>
        <ul class="text-gray-700 text-sm space-y-2">
          <li><strong>Nombre:</strong> {{ details.project?.name }}</li>
          <li><strong>ID:</strong> {{ details.project?.projectId }}</li>
          <li><strong>Moneda:</strong> {{ details.project?.currency?.code || 'COP' }}</li>
          <li><strong>Período:</strong> {{ details.project?.period || 'N/A' }}</li>
        </ul>
      </div>
    </section>

    <!-- OBSERVACIONES DEL ACUERDO CORPORATIVO (siempre visible) -->
    <section class="mb-8">
      <div class="bg-amber-50 p-5 rounded-xl border border-amber-200">
        <h3 class="text-sm font-semibold text-amber-800 mb-2 flex items-center gap-2">
          <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Observaciones del Acuerdo
        </h3>
        <p class="text-sm text-amber-900" *ngIf="details.observations">{{ details.observations }}</p>
        <p class="text-sm text-amber-700 italic" *ngIf="!details.observations">Sin observaciones</p>
      </div>
    </section>

    <!-- 🆕 BANNER DE INSCRIPCIÓN INTERNACIONAL -->
    <section *ngIf="isInternationalEnrollment" class="mb-8">
      <div class="bg-gradient-to-r from-purple-50 to-indigo-50 p-6 rounded-xl border border-purple-200">
        <div class="flex items-start gap-4">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
              <span class="text-2xl">🌍</span>
            </div>
          </div>
          <div class="flex-1">
            <h3 class="text-lg font-bold text-purple-800 flex items-center gap-2">
              Inscripción Corporativa Internacional
              <span class="px-2 py-0.5 text-xs bg-purple-200 text-purple-800 rounded-full">{{
                getEnrollmentCurrencyCode() }}</span>
            </h3>
            <p class="text-sm text-purple-700 mt-1">
              Esta inscripción corporativa está en moneda extranjera. Todos los montos se muestran en
              <strong>{{ getEnrollmentCurrencyCode() }}</strong> y los pagos a Wompi se convierten automáticamente a
              COP.
            </p>

            <!-- Información de tasa de cambio -->
            <div class="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
              <div class="bg-white p-3 rounded-lg border border-purple-200">
                <p class="text-xs text-purple-600 font-medium">Moneda</p>
                <p class="text-lg font-bold text-purple-900">{{ getEnrollmentCurrencyCode() }}</p>
              </div>
              <div class="bg-white p-3 rounded-lg border border-purple-200">
                <p class="text-xs text-purple-600 font-medium">Tasa de Cambio (TRM)</p>
                <p class="text-lg font-bold text-purple-900">{{ formatExchangeRate() }}</p>
              </div>
              <div class="bg-white p-3 rounded-lg border border-purple-200">
                <p class="text-xs text-purple-600 font-medium">Valor Total ({{ getEnrollmentCurrencyCode() }})</p>
                <p class="text-lg font-bold text-purple-900">{{ formatCurrencyValue(getTotalEnrollmentValue()) }}</p>
              </div>
              <div class="bg-white p-3 rounded-lg border border-purple-200">
                <p class="text-xs text-purple-600 font-medium">Equivalente COP</p>
                <p class="text-lg font-bold text-purple-900">{{ calculateCOPEquivalent(getTotalEnrollmentValue()) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- RESUMEN FINANCIERO DETALLADO -->
    <section class="mb-10">
      <h2 class="text-2xl font-semibold mb-6 text-gray-800 flex items-center gap-2">
        <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
        Resumen Financiero
      </h2>

      <!-- Empresa vs Participantes -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <!-- Resumen Empresa -->
        <div class="bg-blue-50 p-6 rounded-xl border border-blue-200">
          <h3 class="text-lg font-semibold text-blue-800 mb-4">💼 Empresa</h3>
          <div class="grid grid-cols-2 gap-4">
            <div class="bg-white p-3 rounded-lg border border-blue-100">
              <p class="text-sm text-blue-600 mb-1">Total</p>
              <p class="text-lg font-bold text-blue-800">{{ formatCurrencyValue(getCompanyTotalAmount()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getCompanyTotalAmount()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-green-100">
              <p class="text-sm text-green-600 mb-1">Pagado</p>
              <p class="text-lg font-bold text-green-800">{{ formatCurrencyValue(getCompanyPaidAmount()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getCompanyPaidAmount()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-orange-100">
              <p class="text-sm text-orange-600 mb-1">Pendiente</p>
              <p class="text-lg font-bold text-orange-800">{{ formatCurrencyValue(getCompanyPendingAmount()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getCompanyPendingAmount()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-red-100">
              <p class="text-sm text-red-600 mb-1">Vencido</p>
              <p class="text-lg font-bold text-red-800">{{ formatCurrencyValue(getCompanyOverdueAmount()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getCompanyOverdueAmount()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-rose-100 col-span-2">
              <p class="text-sm text-rose-700 mb-1">Cartera Castigada</p>
              <p class="text-lg font-bold text-rose-800">{{ formatCurrencyValue(getCompanyCastigadoAmount()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getCompanyCastigadoAmount()) }}</p>
            </div>
          </div>
          <div class="mt-4 text-center">
            <span class="text-sm text-blue-700">
              {{ getCompanyCompletedPayments() }} de {{ details.companyPaymentPlans?.length || 0 }} cuotas pagadas
            </span>
          </div>
        </div>

        <!-- Resumen Participantes -->
        <div class="bg-green-50 p-6 rounded-xl border border-green-200">
          <h3 class="text-lg font-semibold text-green-800 mb-4">👥 Participantes</h3>
          <div class="grid grid-cols-2 gap-4">
            <div class="bg-white p-3 rounded-lg border border-green-100">
              <p class="text-sm text-green-600 mb-1">Total</p>
              <p class="text-lg font-bold text-green-800">{{ formatCurrencyValue(getTotalParticipantsAmount()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getTotalParticipantsAmount()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-emerald-100">
              <p class="text-sm text-emerald-600 mb-1">Pagado</p>
              <p class="text-lg font-bold text-emerald-800">{{ formatCurrencyValue(getTotalParticipantsPaid()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getTotalParticipantsPaid()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-orange-100">
              <p class="text-sm text-orange-600 mb-1">Pendiente</p>
              <p class="text-lg font-bold text-orange-800">{{ formatCurrencyValue(getTotalParticipantsPending()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getTotalParticipantsPending()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-rose-100">
              <p class="text-sm text-rose-700 mb-1">Castigada</p>
              <p class="text-lg font-bold text-rose-800">{{ formatCurrencyValue(getTotalParticipantsCastigado()) }}</p>
              <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
                calculateCOPEquivalent(getTotalParticipantsCastigado()) }}</p>
            </div>
            <div class="bg-white p-3 rounded-lg border border-gray-100 col-span-2">
              <p class="text-sm text-gray-600 mb-1">Participantes</p>
              <p class="text-lg font-bold text-gray-800">{{ details.participantEnrollments?.length || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PLAN DE PAGOS DE LA EMPRESA -->
    <section class="mb-10" [class.border]="isEnrollmentCancelled" [class.border-red-200]="isEnrollmentCancelled" [class.rounded-xl]="isEnrollmentCancelled">
      <!-- Banner de Anulación -->
      <div *ngIf="isEnrollmentCancelled"
        class="bg-red-50 border-b border-red-200 px-4 py-3 flex items-center gap-3 rounded-t-xl">
        <div class="bg-red-100 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0">
          <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-semibold text-red-800">Plan de Pagos Anulado</p>
          <p class="text-xs text-red-600">Esta inscripción ha sido reversada. El plan de pagos es de solo lectura.</p>
        </div>
        <div class="inline-flex items-center px-2.5 py-1 rounded-full bg-red-100 text-red-700 text-xs font-medium flex-shrink-0">
          <span class="w-1.5 h-1.5 bg-red-500 rounded-full mr-1.5"></span>
          Reversada
        </div>
      </div>

      <!-- 🆕 Stats de cuotas de empresa -->
      <div *ngIf="details?.companyPaymentPlans?.length" class="mb-4"
           [class.px-4]="isEnrollmentCancelled" [class.pt-4]="isEnrollmentCancelled">
        <app-installment-stats [plans]="details.companyPaymentPlans" variant="card"
          title="Estado de cuotas - Empresa"></app-installment-stats>
      </div>

      <div class="flex items-center justify-between mb-6" [class.px-4]="isEnrollmentCancelled" [class.pt-4]="isEnrollmentCancelled">
        <h2 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
          <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          Plan de Pagos - Empresa
        </h2>

        <!-- Acciones -->
        <div *ngIf="!isEnrollmentCancelled" class="flex gap-3 items-center flex-wrap">
          <!-- Toggle de cobro automático -->
          <div class="flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2"
            [title]="details?.autoGeneratePaymentLinks ? 'El sistema enviará links de pago automáticamente por email' : 'Los pagos se gestionan manualmente'">
            <span class="text-xs font-medium text-gray-700">📧 Cobro automático</span>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" [checked]="details?.autoGeneratePaymentLinks" (change)="toggleAutoPayment($event)"
                class="sr-only peer">
              <div
                class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600">
              </div>
            </label>
          </div>

          <button (click)="goToEditCompanyPlans()"
            [disabled]="isEditCompanyPlanDisabled()"
            [title]="isEditCompanyPlanDisabled() ? 'Todas las cuotas están pagadas y no hay saldo pendiente, no hay nada que editar' : ''"
            class="inline-flex items-center gap-2 text-sm border px-3 py-1.5 rounded-md shadow-sm transition"
            [ngClass]="isEditCompanyPlanDisabled()
              ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
              : 'bg-white text-purple-600 border-purple-100 hover:bg-purple-50'">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Editar Plan Empresa
          </button>
          <a [routerLink]="['/dashboard/enrollments/payment-plans/history', agreementId]"
            [queryParams]="{ type: 'corporate' }" target="_blank"
            class="inline-flex items-center gap-2 text-sm text-gray-600 border border-gray-200 px-3 py-1.5 rounded-md hover:bg-gray-50 hover:text-gray-800 transition">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Ver historial
          </a>
          <!-- 🆕 Ver comprobantes empresariales (NIT/razón + proyecto) -->
          <button type="button" (click)="goToReceiptsCompany()"
            title="Ver los comprobantes de ingreso del acuerdo empresarial en este proyecto, en una nueva pestaña"
            class="inline-flex items-center gap-2 text-sm text-purple-700 border border-purple-200 px-3 py-1.5 rounded-md hover:bg-purple-50 hover:text-purple-800 transition">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Ver comprobantes ↗
          </button>
          <button (click)="toggleCompanyPunishMode()"
            [disabled]="!isCompanyPunishMode && areAllCompanyPaymentPlansPaid()"
            [title]="(!isCompanyPunishMode && areAllCompanyPaymentPlansPaid()) ? 'Todas las cuotas están pagadas, no hay cartera para castigar' : ''"
            class="inline-flex items-center gap-2 text-sm border px-3 py-1.5 rounded-md shadow-sm transition"
            [ngClass]="{
              'bg-red-100 ring-2 ring-red-400 border-red-200 text-red-700 hover:bg-red-50': isCompanyPunishMode,
              'border-red-200 text-red-700 hover:bg-red-50': !isCompanyPunishMode && !areAllCompanyPaymentPlansPaid(),
              'border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed': !isCompanyPunishMode && areAllCompanyPaymentPlansPaid()
            }">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            {{ isCompanyPunishMode ? 'Cancelar Gestión' : 'Gestionar Castigo' }}
          </button>
        </div>
      </div>

      <!-- Resumen rápido -->
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
        <div class="bg-blue-50 p-4 rounded-xl border border-blue-200">
          <p class="text-xs font-medium text-blue-600 mb-1">Total Empresa</p>
          <p class="text-lg font-bold text-blue-800">{{ formatCurrencyValue(getCompanyTotalAmount()) }}</p>
          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
            calculateCOPEquivalent(getCompanyTotalAmount()) }}</p>
        </div>
        <div class="bg-green-50 p-4 rounded-xl border border-green-200">
          <p class="text-xs font-medium text-green-600 mb-1">Pagado</p>
          <p class="text-lg font-bold text-green-800">{{ formatCurrencyValue(getCompanyPaidAmount()) }}</p>
          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
            calculateCOPEquivalent(getCompanyPaidAmount()) }}</p>
        </div>
        <div class="bg-orange-50 p-4 rounded-xl border border-orange-200">
          <p class="text-xs font-medium text-orange-600 mb-1">Pendiente</p>
          <p class="text-lg font-bold text-orange-800">{{ formatCurrencyValue(getCompanyPendingAmount()) }}</p>
          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
            calculateCOPEquivalent(getCompanyPendingAmount()) }}</p>
        </div>
        <div class="bg-red-50 p-4 rounded-xl border border-red-200">
          <p class="text-xs font-medium text-red-600 mb-1">Vencido</p>
          <p class="text-lg font-bold text-red-800">{{ formatCurrencyValue(getCompanyOverdueAmount()) }}</p>
          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
            calculateCOPEquivalent(getCompanyOverdueAmount()) }}</p>
        </div>
        <div class="bg-rose-50 p-4 rounded-xl border border-rose-200">
          <p class="text-xs font-medium text-rose-700 mb-1">Castigada</p>
          <p class="text-lg font-bold text-rose-800">{{ formatCurrencyValue(getCompanyCastigadoAmount()) }}</p>
          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400">≈ {{
            calculateCOPEquivalent(getCompanyCastigadoAmount()) }}</p>
        </div>
      </div>

      <!-- Panel de Gestión de Castigo (Empresa) -->
      <div *ngIf="isCompanyPunishMode"
        class="mb-6 p-4 bg-red-50 rounded-xl border-2 border-red-200 shadow-sm animate-fade-in">
        <div class="flex items-center gap-2 mb-4">
          <div class="p-2 bg-red-100 rounded-lg">
            <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div>
            <h3 class="font-bold text-red-900">Modo de Gestión de Castigo (Empresa)</h3>
            <p class="text-sm text-red-700">Selecciona las cuotas de la empresa que deseas castigar o descastigar
              manualmenfe.</p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Razón del cambio <span
                class="text-red-500">*</span></label>
            <input [(ngModel)]="punishReason" type="text"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
              placeholder="Ej: Acuerdo de pago incumplido / Error operativo">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Notas adicionales (Opcional)</label>
            <input [(ngModel)]="punishNotes" type="text"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
              placeholder="Detalles adicionales...">
          </div>
        </div>

        <div class="flex items-center justify-between bg-white p-3 rounded-lg border border-red-100">
          <span class="text-sm font-medium text-gray-600">
            <span class="font-bold text-red-600">{{ selectedCompanyPlanIds.length }}</span> cuotas seleccionadas
          </span>
          <div class="flex gap-2">
            <button (click)="executeCompanyPunishAction('punish')"
              [disabled]="selectedCompanyPlanIds.length === 0 || !punishReason"
              class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm transition flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
              Castigar Seleccionadas
            </button>
            <button (click)="executeCompanyPunishAction('unpunish')"
              [disabled]="selectedCompanyPlanIds.length === 0 || !punishReason"
              class="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm transition flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Descastigar
            </button>
          </div>
        </div>
      </div>

      <!-- Tabla de pagos mejorada -->
      <div class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="w-12" *ngIf="!isCompanyPunishMode"></th>
              <th class="w-12 px-4 py-3 bg-red-50" *ngIf="isCompanyPunishMode">
                <input type="checkbox" (change)="selectAllCompanyPlans()"
                  [checked]="selectedCompanyPlanIds.length === details.companyPaymentPlans.length && details.companyPaymentPlans.length > 0"
                  class="rounded border-gray-300 text-red-600 focus:ring-red-500">
              </th>
              <!-- 🆕 Handle de drag (solo super-admin) -->
              <th *ngIf="isSuperAdmin" class="w-8 px-2 py-3" title="Arrastrá para reordenar"></th>
              <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Cuota</th>
              <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Vencimiento</th>
              <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Monto</th>
              <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Estado</th>
              <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white"
                 cdkDropList
                 [cdkDropListDisabled]="!isSuperAdmin"
                 (cdkDropListDropped)="onCompanyPlanDrop($event)">
            <ng-container *ngFor="let plan of details.companyPaymentPlans">
              <tr cdkDrag
                  [cdkDragData]="plan"
                  [cdkDragDisabled]="!isSuperAdmin"
                  cdkDragLockAxis="y"
                  [ngClass]="{
                    'bg-amber-50/50': isPaymentOverdue(plan) && !plan.isPunished,
                    'bg-red-50/70': plan.isPunished
                  }" class="hover:bg-gray-50">
                <td *ngIf="!isCompanyPunishMode" class="hover:bg-gray-50 transition cursor-pointer text-center px-2"
                  (click)="toggleCollapse(plan)">
                  <svg [class.rotate-180]="!plan.isCollapsed" class="w-5 h-5 text-gray-400 transition-transform"
                    viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clip-rule="evenodd" />
                  </svg>
                </td>
                <td *ngIf="isCompanyPunishMode" class="text-center px-4 py-3 bg-red-50/30">
                  <input type="checkbox" [checked]="isCompanyPlanSelected(plan.id)"
                    (change)="toggleCompanyPlanSelection(plan.id)" [disabled]="plan.paymentStatus === 'PAID'"
                    class="rounded border-gray-300 text-red-600 focus:ring-red-500 w-5 h-5 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                </td>
                <!-- 🆕 Drag handle (solo super-admin) -->
                <td *ngIf="isSuperAdmin" class="px-2 py-3 text-center text-gray-300 hover:text-gray-600 cursor-grab active:cursor-grabbing"
                    cdkDragHandle
                    title="Arrastrar para reordenar">
                  <svg class="w-4 h-4 inline-block" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M7 4a1 1 0 100 2 1 1 0 000-2zM7 9a1 1 0 100 2 1 1 0 000-2zM7 14a1 1 0 100 2 1 1 0 000-2zM13 4a1 1 0 100 2 1 1 0 000-2zM13 9a1 1 0 100 2 1 1 0 000-2zM13 14a1 1 0 100 2 1 1 0 000-2z"/>
                  </svg>
                </td>
                <td class="px-4 py-3 font-medium text-gray-900">
                  <div class="flex items-center gap-2">
                    <span>#{{ plan.installmentNumber }}</span>
                    <!-- 🆕 Indicador de cartera castigada -->
                    <span *ngIf="plan.isPunished"
                      class="px-2 py-1 text-xs font-bold bg-red-200 text-red-800 rounded-full flex items-center gap-1">
                      <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd" />
                      </svg>
                      Castigada
                    </span>
                  </div>
                </td>
                <td class="px-4 py-3">
                  <div class="text-sm text-gray-900">{{ plan.dueDate | date:'mediumDate' }}</div>
                  <div *ngIf="isPaymentOverdue(plan)" class="text-xs text-red-600 mt-1">
                    {{ getDaysOverdue(plan) }} días de atraso
                  </div>
                </td>
                <td class="px-4 py-3">
                  <div class="text-sm font-semibold text-gray-900">
                    {{ formatCurrencyValue(plan.amountToPay) }}
                  </div>
                  <div class="text-xs text-purple-500" *ngIf="isInternationalEnrollment && plan.amountToPay">
                    ≈ {{ calculatePlanCOPEquivalent(plan, plan.amountToPay) }}
                    <span class="ml-1 text-[10px] text-gray-400">(TRM {{ formatPlanExchangeRate(plan) }})</span>
                  </div>
                  <div class="text-xs text-gray-500" *ngIf="plan.amountPaid">
                    Pagado: {{ formatCurrencyValue(plan.amountPaid) }}
                    <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1">
                      ≈ {{ calculatePlanCOPEquivalent(plan, plan.amountPaid) }}
                    </span>
                  </div>
                  <div class="text-xs text-red-500" *ngIf="(plan.amountToPay - plan.amountPaid) > 0">
                    Saldo: {{ formatCurrencyValue((plan.amountToPay - plan.amountPaid)) }}
                    <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1">
                      ≈ {{ calculatePlanCOPEquivalent(plan, plan.amountToPay - plan.amountPaid) }}
                    </span>
                  </div>

                  <!-- Payment Link Manager para Empresa en tabla -->
                  <div class="mt-2" *ngIf="plan.paymentLinkUrl">
                    <app-payment-link-manager [paymentLinkUrl]="plan.paymentLinkUrl"
                      [paymentLinkId]="plan.paymentLinkId" [paymentLinkWompiId]="plan.paymentLinkWompiId"
                      [isActive]="plan.paymentLinkActive !== false" [showDeactivateButton]="true" [size]="'sm'"
                      (paymentLinkDeactivated)="onCompanyPaymentLinkDeactivated()">
                    </app-payment-link-manager>
                  </div>
                </td>
                <td class="px-4 py-3">
                  <div class="flex items-center gap-2">
                    <span class="w-2 h-2 rounded-full" [ngClass]="{
                      'bg-green-500': plan.paymentStatus === 'PAID',
                      'bg-amber-500': plan.paymentStatus === 'PENDING',
                      'bg-red-600': plan.paymentStatus === 'OVERDUE',
                      'bg-blue-500': plan.paymentStatus === 'LINK_GENERATED'
                    }"></span>
                    <span class="text-sm font-medium">{{ getPaymentStatusLabel(plan.paymentStatus) }}</span>
                  </div>
                </td>
                <td class="px-4 py-3">
                  <div class="flex gap-2">
                    <a [routerLink]="['/dashboard/income-receipts/new']"
                      [queryParams]="{companyId: details.company?.id, projectId: details.project?.id, corporateEnrollmentId: details.id, installmentNumber: plan.installmentNumber, isCompanyPayment: true}"
                      *ngIf="plan.paymentStatus !== 'PAID' && !isEnrollmentCancelled"
                      class="text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                      </svg>
                      Pagar
                    </a>
                    <!-- 🔐 Editar (solo super-admin): abre modal con todas las acciones admin -->
                    <button *ngIf="isSuperAdmin" (click)="openAdminMenu(plan)"
                      title="Acciones admin sobre esta cuota corporativa"
                      class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300 transition-colors">
                      <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                      Editar
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Detalles colapsables para planes de empresa -->
              <tr *ngIf="!plan.isCollapsed" class="bg-gray-50">
                <td colspan="6" class="px-4 py-3">
                  <div class="pl-6 border-l-2" [ngClass]="plan.isPunished ? 'border-red-400' : 'border-blue-200'">
                    <h4 class="text-sm font-medium text-gray-700 mb-3">Detalles del Pago Empresa</h4>

                    <!-- Observaciones de la cuota (siempre visible) -->
                    <div *ngIf="!plan.isPunished"
                      class="mb-4 bg-blue-50 p-4 rounded-lg border border-blue-200">
                      <h5 class="text-xs font-bold text-blue-600 uppercase mb-2 flex items-center gap-2">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        Observaciones
                      </h5>
                      <p *ngIf="plan.observations" class="text-sm text-blue-900">{{ plan.observations }}</p>
                      <p *ngIf="!plan.observations" class="text-sm text-blue-400 italic">Sin observaciones</p>
                    </div>

                    <!-- 🆕 Información de Cartera Castigada -->
                    <div *ngIf="plan.isPunished" class="mb-4 p-4 bg-red-50 rounded-lg border border-red-200">
                      <h5 class="text-sm font-bold text-red-800 flex items-center gap-2 mb-3">
                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                        Cartera Castigada
                      </h5>
                      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                          <p class="text-xs font-medium text-red-600">Tipo de Movimiento:</p>
                          <p class="text-sm font-semibold text-red-900">{{ getMovementTypeLabel(plan.movementType) }}
                          </p>
                        </div>
                        <div *ngIf="plan.movementDate">
                          <p class="text-xs font-medium text-red-600">Fecha del Castigamiento:</p>
                          <p class="text-sm font-semibold text-red-900">{{ plan.movementDate | date:'medium' }}</p>
                        </div>
                        <div>
                          <p class="text-xs font-medium text-red-600">Monto Castigado:</p>
                          <p class="text-sm font-semibold text-red-900">
                            {{ formatCurrencyValue(plan.amountToPay - (plan.amountPaid || 0)) }}
                          </p>
                          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">
                            ≈ {{ calculateCOPEquivalent(plan.amountToPay - (plan.amountPaid || 0)) }}
                          </p>
                        </div>
                      </div>
                      <div *ngIf="plan.observations" class="mt-3 p-3 bg-red-100 rounded">
                        <p class="text-xs font-medium text-red-600 mb-1">📝 Observaciones:</p>
                        <p class="text-sm text-red-900">{{ plan.observations }}</p>
                      </div>
                    </div>

                    <!-- Payment Link Manager para Empresa -->
                    <div class="mb-4" *ngIf="plan.paymentLinkUrl">
                      <app-payment-link-manager [paymentLinkUrl]="plan.paymentLinkUrl"
                        [paymentLinkId]="plan.paymentLinkId" [paymentLinkWompiId]="plan.paymentLinkWompiId"
                        [isActive]="plan.paymentLinkActive !== false" [showDeactivateButton]="true" [size]="'sm'"
                        (paymentLinkDeactivated)="onCompanyPaymentLinkDeactivated()">
                      </app-payment-link-manager>
                    </div>

                    <!-- Tabs de comprobantes -->
                    <div *ngIf="plan.incomeReceipts?.length > 0 || plan.paymentLinkId" class="mb-3 border-b border-gray-200">
                      <nav class="flex gap-4">
                        <button (click)="setCompanyPlanTab(plan.id, 'active')"
                          class="pb-2 text-xs font-medium border-b-2 transition-colors"
                          [ngClass]="getCompanyPlanTab(plan.id) === 'active' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                          Comprobantes Activos
                          <span class="ml-1 bg-blue-100 text-blue-600 py-0.5 px-1.5 rounded-full text-xs">{{ getActiveReceipts(plan).length }}</span>
                        </button>
                        <button *ngIf="getCancelledReceipts(plan).length > 0"
                          (click)="setCompanyPlanTab(plan.id, 'cancelled')"
                          class="pb-2 text-xs font-medium border-b-2 transition-colors"
                          [ngClass]="getCompanyPlanTab(plan.id) === 'cancelled' ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                          Anulados
                          <span class="ml-1 bg-red-100 text-red-600 py-0.5 px-1.5 rounded-full text-xs">{{ getCancelledReceipts(plan).length }}</span>
                        </button>
                        <button *ngIf="plan.paymentLinkId"
                          (click)="setCompanyPlanTab(plan.id, 'emails'); loadEmailsForPlan(plan)"
                          class="pb-2 text-xs font-medium border-b-2 transition-colors"
                          [ngClass]="getCompanyPlanTab(plan.id) === 'emails' ? 'border-violet-500 text-violet-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                          Emails
                          <span *ngIf="hasEmails(plan)" class="ml-1 bg-violet-100 text-violet-600 py-0.5 px-1.5 rounded-full text-xs">{{ getEmailsForPlan(plan).length }}</span>
                        </button>
                      </nav>
                    </div>

                    <!-- Comprobantes activos -->
                    <ng-container *ngIf="getCompanyPlanTab(plan.id) === 'active'">
                    <div *ngFor="let receipt of getActiveReceipts(plan)" class="mb-4 last:mb-0">
                      <div class="p-3 rounded-lg shadow-sm relative overflow-hidden bg-white border border-gray-200">
                        <div class="relative z-10">
                        <div class="flex justify-between items-start mb-3">
                          <div>
                            <p class="text-sm font-bold mb-1" [ngClass]="receipt.isCancelled ? 'text-red-800 line-through' : 'text-gray-900'">{{ receipt.concept }}</p>
                            <div class="space-y-0.5">
                              <p class="text-xs text-gray-500 font-medium flex items-center gap-1">
                                <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor"
                                  viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Creación: {{ receipt.createdAt | date:'mediumDate' }}
                              </p>
                              <p class="text-xs text-gray-500 font-medium flex items-center gap-1">
                                <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor"
                                  viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Pago:
                                <span *ngIf="receipt.transactionDate">{{ receipt.transactionDate | date:'mediumDate'
                                  }}</span>
                                <span *ngIf="!receipt.transactionDate" class="text-gray-400 italic">No disponible</span>
                              </p>
                            </div>
                          </div>
                          <span class="text-xs font-medium px-2 py-1 rounded-full ml-2"
                            [ngClass]="receipt.isManualPayment ? 'bg-amber-100 text-amber-800' : 'bg-green-100 text-green-800'">
                            {{ receipt.isManualPayment ? 'Manual' : 'Automático' }}
                          </span>
                        </div>

                        <!-- 🆕 Información de Tasa de Cambio (si aplica) -->
                        <div *ngIf="hasReceiptExchangeRate(receipt)"
                          class="bg-purple-50 p-3 rounded-lg border-l-4 border-purple-400 mb-3">
                          <h4 class="text-xs font-semibold mb-2 text-purple-800 flex items-center gap-1">
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 8c-1.657 0-3 .672-3 1.5S10.343 11 12 11s3-.672 3-1.5S13.657 8 12 8zm0 8c-1.657 0-3 .672-3 1.5S10.343 19 12 19s3-.672 3-1.5S13.657 16 12 16zm0-4c-1.657 0-3 .672-3 1.5S10.343 15 12 15s3-.672 3-1.5S13.657 12 12 12z" />
                            </svg>
                            Información de Tasa de Cambio
                          </h4>
                          <div class="grid grid-cols-2 gap-2 text-xs">
                            <div>
                              <p class="text-purple-600 font-medium">Moneda:</p>
                              <p class="text-purple-900 font-semibold">{{ receipt.currencyCode }}</p>
                            </div>
                            <div>
                              <p class="text-purple-600 font-medium">Tasa (TRM):</p>
                              <p class="text-purple-900 font-semibold">{{ receipt.exchangeRate | number:'1.2-4' }}</p>
                            </div>
                          </div>
                        </div>

                        <div class="mt-2 grid grid-cols-3 gap-2">
                          <div>
                            <p class="text-xs text-gray-500">Bruto</p>
                            <p class="text-sm font-medium text-yellow-700">{{ formatCurrencyValue(receipt.grossAmount,
                              receipt.currencySymbol, receipt.currencyCode) }}</p>
                            <p *ngIf="hasReceiptExchangeRate(receipt)" class="text-xs text-purple-500">≈ {{
                              getReceiptCOPEquivalent(receipt, receipt.grossAmount) }}</p>
                          </div>
                          <div>
                            <p class="text-xs text-gray-500">Descuentos</p>
                            <p class="text-sm font-medium text-red-700">{{ formatCurrencyValue(receipt.totalFees,
                              receipt.currencySymbol, receipt.currencyCode) }}</p>
                            <p *ngIf="hasReceiptExchangeRate(receipt)" class="text-xs text-purple-500">≈ {{
                              getReceiptCOPEquivalent(receipt, receipt.totalFees) }}</p>
                          </div>
                          <div>
                            <p class="text-xs text-gray-500">Neto</p>
                            <p class="text-sm font-medium text-green-700">{{ formatCurrencyValue(receipt.netAmount,
                              receipt.currencySymbol, receipt.currencyCode) }}</p>
                            <p *ngIf="hasReceiptExchangeRate(receipt)" class="text-xs text-purple-500">≈ {{
                              getReceiptCOPEquivalent(receipt, receipt.netAmount) }}</p>
                          </div>
                          <div>
                            <p class="text-xs text-gray-500">Método</p>
                            <p class="text-sm text-gray-700">{{ receipt.paymentMethod?.name || 'N/A' }}</p>
                          </div>
                          <div>
                            <p class="text-xs text-gray-500">Comprobante</p>
                            <div class="flex items-center gap-3 flex-wrap">
                              <a [routerLink]="['/dashboard/income-receipts/view', receipt.id]" target="_blank"
                                class="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5"
                                  viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                </svg>
                                Ver
                              </a>
                              <!-- 🆕 Botón Anular comprobante -->
                              <button *ngIf="canCancelReceipt(receipt)"
                                (click)="openCancelReceiptModal(receipt)"
                                title="Anular este comprobante (revierte el pago de la cuota)"
                                class="text-sm font-medium text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-0.5 rounded-md flex items-center gap-1 transition-colors">
                                <i class="fas fa-ban"></i>
                                Anular
                              </button>
                              <span *ngIf="!receipt.isCancelled && receipt.isBankReconciled"
                                title="No se puede anular: comprobante conciliado bancariamente"
                                class="text-sm font-medium text-gray-400 cursor-not-allowed opacity-60 px-2 py-0.5 rounded-md flex items-center gap-1">
                                <i class="fas fa-ban"></i>
                                Anular
                              </span>
                            </div>
                          </div>
                        </div>
                        <!-- Observaciones del comprobante (siempre visible) -->
                        <div class="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                          <p class="text-xs font-medium text-blue-600 mb-1 flex items-center gap-1">
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Observaciones:
                          </p>
                          <p *ngIf="receipt.observations" class="text-xs text-blue-900">{{ receipt.observations }}</p>
                          <p *ngIf="!receipt.observations" class="text-xs text-blue-400 italic">Sin observaciones</p>
                        </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="getActiveReceipts(plan).length === 0" class="text-center py-4 text-gray-400 text-sm">
                      No hay comprobantes activos para esta cuota
                    </div>
                    </ng-container>

                    <!-- Comprobantes anulados -->
                    <ng-container *ngIf="getCompanyPlanTab(plan.id) === 'cancelled'">
                    <div *ngFor="let receipt of getCancelledReceipts(plan)" class="mb-4 last:mb-0">
                      <div class="p-3 rounded-lg shadow-sm relative overflow-hidden bg-red-50 border border-red-200">
                        <div class="absolute -inset-[25%] pointer-events-none" style="transform: rotate(-30deg);">
                          <div class="flex flex-col items-center justify-center h-full gap-8">
                            <span class="text-red-400/15 text-4xl font-black tracking-[0.2em] select-none whitespace-nowrap">ANULADO</span>
                            <span class="text-red-400/15 text-4xl font-black tracking-[0.2em] select-none whitespace-nowrap">ANULADO</span>
                            <span class="text-red-400/15 text-4xl font-black tracking-[0.2em] select-none whitespace-nowrap">ANULADO</span>
                          </div>
                        </div>
                        <div class="relative z-10">
                          <div class="flex justify-between items-start mb-3">
                            <div>
                              <p class="text-sm font-bold mb-1 text-red-800 line-through">{{ receipt.concept }}</p>
                              <div class="space-y-0.5">
                                <p class="text-xs text-gray-500 font-medium">Creación: {{ receipt.createdAt | date:'mediumDate' }}</p>
                                <p *ngIf="receipt.cancelledAt" class="text-xs text-red-600 font-medium">Anulado: {{ receipt.cancelledAt | date:'mediumDate' }}</p>
                                <p *ngIf="receipt.cancelledBy" class="text-xs text-red-600">Por: {{ receipt.cancelledBy }}</p>
                                <p *ngIf="receipt.cancellationReason" class="text-xs text-red-600">Motivo: {{ receipt.cancellationReason }}</p>
                              </div>
                            </div>
                            <span class="text-xs font-medium px-2 py-1 rounded-full bg-red-200 text-red-800">Anulado</span>
                          </div>
                          <div class="mt-2 grid grid-cols-3 gap-2">
                            <div>
                              <p class="text-xs text-gray-500">Bruto</p>
                              <p class="text-sm font-medium text-gray-500 line-through">{{ formatCurrencyValue(receipt.grossAmount, receipt.currencySymbol, receipt.currencyCode) }}</p>
                            </div>
                            <div>
                              <p class="text-xs text-gray-500">Neto</p>
                              <p class="text-sm font-medium text-gray-500 line-through">{{ formatCurrencyValue(receipt.netAmount, receipt.currencySymbol, receipt.currencyCode) }}</p>
                            </div>
                            <div>
                              <p class="text-xs text-gray-500">Comprobante</p>
                              <a [routerLink]="['/dashboard/income-receipts/view', receipt.id]" target="_blank"
                                class="text-blue-600 hover:text-blue-800 text-sm font-medium">Ver</a>
                            </div>
                          </div>
                          <div *ngIf="receipt.observations" class="mt-3 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                            <p class="text-xs font-medium text-yellow-700 mb-1">Observaciones:</p>
                            <p class="text-xs text-yellow-900">{{ receipt.observations }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="getCancelledReceipts(plan).length === 0" class="text-center py-4 text-gray-400 text-sm">
                      No hay comprobantes anulados
                    </div>
                    </ng-container>

                    <!-- Emails enviados (empresa) -->
                    <ng-container *ngIf="getCompanyPlanTab(plan.id) === 'emails'">
                      <div *ngIf="isEmailsLoading(plan)" class="flex items-center justify-center py-6">
                        <svg class="animate-spin h-5 w-5 text-violet-500 mr-2" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        <span class="text-sm text-gray-500">Cargando emails...</span>
                      </div>
                      <div *ngIf="!isEmailsLoading(plan) && !hasEmails(plan)" class="text-center py-4 text-gray-400 text-sm">
                        No se han enviado emails para este link de pago.
                      </div>
                      <div *ngFor="let email of getEmailsForPlan(plan)" class="mb-3 p-3 bg-white border rounded-lg shadow-sm">
                        <div class="flex items-center justify-between">
                          <div class="flex items-center gap-2 flex-1 min-w-0">
                            <span class="text-xs font-bold px-2 py-0.5 rounded flex-shrink-0"
                              [ngClass]="emailLogService.getSuccessClass(email.isSuccess)">
                              {{ email.isSuccess ? 'Enviado' : 'Error' }}
                            </span>
                            <span class="text-xs font-medium px-2 py-0.5 rounded flex-shrink-0"
                              [ngClass]="emailLogService.getEmailTypeClass(email.emailType)">
                              {{ emailLogService.getEmailTypeLabel(email.emailType) }}
                            </span>
                            <div class="min-w-0">
                              <p class="text-sm font-medium text-gray-900 truncate">{{ email.recipientEmail }}</p>
                              <p *ngIf="email.recipientName" class="text-xs text-gray-500 truncate">{{ email.recipientName }}</p>
                            </div>
                          </div>
                          <div class="text-right flex-shrink-0 ml-4">
                            <p class="text-xs text-gray-500">{{ emailLogService.formatDateTime(email.sentAt) }}</p>
                            <p class="text-xs text-gray-400">{{ email.subject }}</p>
                          </div>
                        </div>
                        <div *ngIf="!email.isSuccess && email.errorMessage" class="mt-2 bg-red-50 border border-red-200 rounded p-2">
                          <p class="text-xs text-red-700">{{ emailLogService.truncateText(email.errorMessage, 200) }}</p>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Estado vacío (sin ningún comprobante) -->
                    <div *ngIf="(!plan.incomeReceipts || plan.incomeReceipts?.length === 0) && getCompanyPlanTab(plan.id) !== 'emails'"
                      class="text-center py-4 text-gray-400 text-sm">
                      No se registran pagos para esta cuota de la empresa
                    </div>

                    <!-- Devoluciones relacionadas con este plan -->
                    <div *ngIf="hasRefundsForCompanyPlan(plan)" class="mt-4 pt-4 border-t border-gray-200">
                      <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                        <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m5 8a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        Devoluciones ({{ getRefundsForCompanyPlan(plan).length }})
                      </h4>
                      <div class="space-y-2">
                        <div *ngFor="let refund of getRefundsForCompanyPlan(plan)"
                          class="bg-red-50 border border-red-200 rounded-lg p-3">
                          <div class="flex justify-between items-start mb-2">
                            <div>
                              <p class="text-sm font-medium text-gray-900">
                                <a [routerLink]="['/refund-vouchers/view', refund.id]" target="_blank"
                                  class="text-blue-600 hover:text-blue-800">
                                  {{ refund.documentNumber }}
                                </a>
                              </p>
                              <p class="text-xs text-gray-500">{{ refund.documentDate | date:'shortDate' }}</p>
                            </div>
                            <span class="text-xs font-medium px-2 py-1 rounded-full" [ngClass]="{
                                    'bg-green-100 text-green-800': refund.status === 'Completed',
                                    'bg-amber-100 text-amber-800': refund.status === 'Pending',
                                    'bg-blue-100 text-blue-800': refund.status === 'Approved',
                                    'bg-purple-100 text-purple-800': refund.status === 'Processing'
                                  }">
                              {{ refund.statusDescription }}
                            </span>
                          </div>
                          <div class="text-sm">
                            <p class="text-gray-600">
                              <span class="font-medium">Monto devuelto:</span>
                              {{ formatRefundAmount(refund.totalRefundedForPlan, refund) }}
                            </p>
                            <p *ngIf="refund.concept" class="text-gray-500 text-xs mt-1">{{ refund.concept }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </section>

    <!-- PARTICIPANTES EN TABLA MEJORADA -->
    <section>
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
          <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          Participantes ({{ details.participantEnrollments?.length || 0 }})
        </h2>
      </div>

      <!-- Tabla moderna de participantes -->
      <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gradient-to-r from-gray-50 to-gray-100">
              <tr>
                <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">Participante</th>
                <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">Estado Financiero</th>
                <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">Progreso</th>
                <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">Próximo Vencimiento</th>
                <th class="px-6 py-4 text-center text-sm font-semibold text-gray-700">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let pe of details.participantEnrollments; trackBy: trackByParticipant"
                class="hover:bg-gray-50 transition-colors duration-150">

                <!-- Información del Participante -->
                <td class="px-6 py-4">
                  <div class="flex items-center gap-4">
                    <div class="flex-shrink-0">
                      <div
                        class="w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center">
                        <span class="text-blue-600 text-sm font-semibold">
                          {{ (pe.enrollment?.participant?.firstName || '?')[0] }}{{
                          (pe.enrollment?.participant?.lastName || '?')[0] }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <div class="text-sm font-semibold text-gray-900">
                        {{ pe.enrollment?.participant?.firstName }} {{ pe.enrollment?.participant?.lastName }}
                      </div>
                      <div class="text-xs text-gray-500">
                        {{ pe.enrollment?.participant?.typeDocument }} {{ pe.enrollment?.participant?.documentId }}
                      </div>
                      <div class="text-xs text-gray-400">
                        {{ pe.enrollment?.participant?.email }}
                      </div>
                    </div>
                  </div>
                </td>

                <!-- Estado Financiero -->
                <td class="px-6 py-4">
                  <div class="space-y-1">
                    <ng-container
                      *ngIf="pe.paymentPlans && pe.paymentPlans.length > 0; else noPaymentPlansForParticipant">
                      <div class="flex justify-between items-center text-xs">
                        <span class="text-gray-500">Total:</span>
                        <div class="text-right">
                          <span class="font-medium text-gray-800">{{
                            formatCurrencyValue(getParticipantTotalAmount(pe.paymentPlans)) }}</span>
                          <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1 block">≈ {{
                            calculateCOPEquivalent(getParticipantTotalAmount(pe.paymentPlans)) }}</span>
                        </div>
                      </div>
                      <div class="flex justify-between items-center text-xs">
                        <span class="text-green-600">Pagado:</span>
                        <div class="text-right">
                          <span class="font-medium text-green-700">{{
                            formatCurrencyValue(getParticipantPaidPlansAmount(pe.paymentPlans)) }}</span>
                          <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1 block">≈ {{
                            calculateCOPEquivalent(getParticipantPaidPlansAmount(pe.paymentPlans)) }}</span>
                        </div>
                      </div>
                      <div class="flex justify-between items-center text-xs">
                        <span class="text-red-600">Vencido:</span>
                        <div class="text-right">
                          <span class="font-medium text-red-700">{{
                            formatCurrencyValue(getParticipantOverdueAmount(pe.paymentPlans)) }}</span>
                          <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1 block">≈ {{
                            calculateCOPEquivalent(getParticipantOverdueAmount(pe.paymentPlans)) }}</span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #noPaymentPlansForParticipant>
                      <div class="text-xs text-blue-600 font-medium">
                        <span class="inline-flex items-center gap-1">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Empresa cubre 100%
                        </span>
                      </div>
                    </ng-template>
                  </div>
                </td>

                <!-- Progreso de Pagos -->
                <td class="px-6 py-4">
                  <div class="space-y-2">
                    <ng-container *ngIf="pe.paymentPlans && pe.paymentPlans.length > 0; else noProgressForParticipant">
                      <div class="flex justify-between text-xs">
                        <span class="text-gray-500">{{ getParticipantCompletedPayments(pe.paymentPlans) }}/{{
                          pe.paymentPlans?.length || 0 }} cuotas</span>
                        <span class="font-medium text-gray-700">
                          {{ getParticipantCompletionPercentage(pe.paymentPlans) | number:'1.0-1' }}%
                        </span>
                      </div>
                      <div class="w-full bg-gray-200 rounded-full h-2">
                        <div
                          class="bg-gradient-to-r from-green-400 to-green-600 h-2 rounded-full transition-all duration-300"
                          [style.width.%]="getParticipantCompletionPercentage(pe.paymentPlans)">
                        </div>
                      </div>
                      <div class="flex justify-between text-xs">
                        <span class="inline-flex items-center gap-1 text-green-600">
                          <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                          {{ getParticipantCompletedPayments(pe.paymentPlans) }} pagadas
                        </span>
                        <span class="inline-flex items-center gap-1 text-orange-600">
                          <span class="w-2 h-2 bg-orange-500 rounded-full"></span>
                          {{ getParticipantPendingPayments(pe.paymentPlans) }} pendientes
                        </span>
                      </div>
                    </ng-container>
                    <ng-template #noProgressForParticipant>
                      <div class="text-center">
                        <div class="text-xs text-gray-500 mb-1">Sin cuotas asignadas</div>
                        <div class="w-full bg-blue-100 rounded-full h-2">
                          <div class="bg-blue-500 h-2 rounded-full w-full"></div>
                        </div>
                        <div class="text-xs text-blue-600 mt-1 font-medium">Cubierto por empresa</div>
                      </div>
                    </ng-template>
                  </div>
                </td>

                <!-- Próximo Vencimiento -->
                <td class="px-6 py-4">
                  <ng-container *ngIf="getNextDuePlan(pe.paymentPlans) as nextPlan; else noNextPlan">
                    <div class="text-sm text-gray-900">{{ nextPlan.dueDate | date:'mediumDate' }}</div>
                    <div class="text-xs font-medium" [ngClass]="{
                           'text-red-600': isPaymentOverdue(nextPlan),
                           'text-orange-600': getDaysUntilDue(nextPlan) <= 7 && getDaysUntilDue(nextPlan) > 0,
                           'text-gray-500': getDaysUntilDue(nextPlan) > 7
                         }">
                      <span *ngIf="isPaymentOverdue(nextPlan)">Vencida hace {{ getDaysOverdue(nextPlan) }} días</span>
                      <span *ngIf="!isPaymentOverdue(nextPlan) && getDaysUntilDue(nextPlan) <= 7">Vence en {{
                        getDaysUntilDue(nextPlan) }} días</span>
                      <span *ngIf="!isPaymentOverdue(nextPlan) && getDaysUntilDue(nextPlan) > 7">
                        {{ formatCurrencyValue(nextPlan.amountToPay) }}
                        <span *ngIf="isInternationalEnrollment" class="text-purple-500 ml-1">
                          ≈ {{ calculatePlanCOPEquivalent(nextPlan, nextPlan.amountToPay) }}
                        </span>
                      </span>
                    </div>
                  </ng-container>
                  <ng-template #noNextPlan>
                    <div class="text-sm text-gray-400">Sin pagos pendientes</div>
                  </ng-template>
                </td>

                <!-- Acciones -->
                <td class="px-6 py-4">
                  <div class="flex items-center justify-center gap-2">
                    <button (click)="openPaymentPlansOffcanvas(pe)"
                      *ngIf="pe.paymentPlans && pe.paymentPlans.length > 0"
                      class="inline-flex items-center gap-2 px-3 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-150 shadow-sm">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                      </svg>
                      Ver Pagos
                    </button>
                    <span *ngIf="!pe.paymentPlans || pe.paymentPlans.length === 0"
                      class="inline-flex items-center gap-2 px-3 py-2 text-xs bg-blue-50 text-blue-700 rounded-lg border border-blue-200">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Sin cuotas propias
                    </span>

                    <a *ngIf="pe.paymentPlans && pe.paymentPlans.length > 0"
                      [routerLink]="isEditParticipantPlanDisabled(pe) ? null : ['/dashboard/enrollments/corporate/edit-participant', details.agreementId, pe.enrollment?.participant?.id]"
                      [queryParams]="{ returnTo: '/dashboard/enrollments/corporate/view/' + details.agreementId }"
                      [attr.aria-disabled]="isEditParticipantPlanDisabled(pe) ? 'true' : null"
                      [ngClass]="isEditParticipantPlanDisabled(pe)
                        ? 'pointer-events-none bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed'
                        : 'bg-white text-green-700 border-green-200 hover:bg-green-50'"
                      class="inline-flex items-center gap-2 px-3 py-2 text-sm border rounded-lg transition-colors duration-150 shadow-sm"
                      [title]="isEditParticipantPlanDisabled(pe) ? 'Todas las cuotas del participante están pagadas y no hay saldo pendiente, no hay nada que editar' : 'Editar plan de pagos del participante'">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                      </svg>
                      Editar plan
                    </a>

                    <a [routerLink]="['/dashboard/participants/profile-participant', pe.enrollment?.participant?.id]"
                      target="_blank"
                      class="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-150"
                      title="Ver perfil">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                      </svg>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Estado vacío -->
      <div *ngIf="!details.participantEnrollments || details.participantEnrollments?.length === 0"
        class="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
        <svg class="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" stroke-width="1.5"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
        </svg>
        <h3 class="text-lg font-medium text-gray-900 mb-2">Sin participantes</h3>
        <p class="text-gray-500">No hay participantes registrados en esta inscripción empresarial.</p>
      </div>
    </section>

    <!-- Leyenda de estados -->
    <div class="mt-8 p-4 bg-gray-50 rounded-lg">
      <h4 class="text-sm font-medium text-gray-700 mb-3">Leyenda de Estados</h4>
      <div class="flex flex-wrap gap-4 items-center text-sm text-gray-600">
        <span class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-green-500"></span>
          Pagado
        </span>
        <span class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-amber-500"></span>
          Pendiente
        </span>
        <span class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-red-600"></span>
          Vencido
        </span>
        <span class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-blue-500"></span>
          Link generado
        </span>
        <!-- 🆕 Indicador de cartera castigada -->
        <span class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-red-800"></span>
          Cartera Castigada
        </span>
      </div>
    </div>

    <!-- 🆕 Resumen de Cartera Castigada -->
    <div *ngIf="hasTotalPunishedInstallments()" class="mt-6 p-4 bg-red-50 rounded-xl border border-red-200">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-bold text-red-800 flex items-center gap-2">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          Resumen de Cartera Castigada Corporativa
        </h3>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white p-4 rounded-lg border border-red-200">
          <p class="text-xs font-medium text-red-600 mb-1">Total Cartera Castigada</p>
          <p class="text-xl font-bold text-red-800">{{ formatCurrencyValue(getTotalPunishedAmount()) }}</p>
          <p *ngIf="isInternationalEnrollment" class="text-xs text-gray-400 mt-1">≈ {{
            calculateCOPEquivalent(getTotalPunishedAmount()) }}</p>
        </div>
        <div class="bg-white p-4 rounded-lg border border-red-200" *ngIf="hasCompanyPunishedInstallments()">
          <p class="text-xs font-medium text-red-600 mb-1">Cuotas Empresa Afectadas</p>
          <p class="text-xl font-bold text-red-800">
            {{ getCompanyPunishedInstallments().length }} de {{ details.companyPaymentPlans?.length || 0 }}
          </p>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-template #loadingTpl>
    <div class="flex items-center justify-center min-h-64">
      <div class="text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p class="text-gray-500">Cargando información de la inscripción corporativa...</p>
      </div>
    </div>
  </ng-template>
  </main>
</div>

<!-- OFFCANVAS PARA PLANES DE PAGO -->
<div *ngIf="isOffcanvasOpen" class="fixed inset-0 z-50 overflow-hidden" (keydown)="onKeydown($event)" tabindex="-1">

  <!-- Overlay -->
  <div class="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300"
    (click)="onOffcanvasOverlayClick($event)">
  </div>

  <!-- Panel lateral -->
  <div
    class="absolute right-0 top-0 h-full w-full max-w-2xl bg-white shadow-2xl transform transition-transform duration-300 ease-in-out"
    [class.translate-x-0]="isOffcanvasOpen" [class.translate-x-full]="!isOffcanvasOpen">

    <!-- Header del offcanvas -->
    <div
      class="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
      <div class="flex items-center gap-3">
        <div
          class="w-10 h-10 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center">
          <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-gray-800">Plan de Pagos</h3>
          <p class="text-sm text-gray-600">
            {{ selectedParticipant?.enrollment?.participant?.firstName }} {{
            selectedParticipant?.enrollment?.participant?.lastName }}
          </p>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <a *ngIf="selectedParticipant?.enrollment?.participant?.id"
          [routerLink]="['/dashboard/enrollments/payment-plans/history', agreementId]"
          [queryParams]="{ type: 'corporate', participantId: selectedParticipant.enrollment?.participant?.id }"
          target="_blank"
          class="inline-flex items-center gap-1.5 text-xs text-gray-600 border border-gray-200 bg-white px-2.5 py-1.5 rounded-md hover:bg-gray-50 hover:text-gray-800 transition"
          title="Ver historial del plan de pagos de este participante">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Ver historial
        </a>
        <!-- 🆕 Ver comprobantes individuales del participante (documento + proyecto) -->
        <button *ngIf="selectedParticipant?.enrollment?.participant?.id" type="button"
          (click)="goToReceiptsParticipant()"
          title="Ver los comprobantes de ingreso de este participante en este proyecto"
          class="inline-flex items-center gap-1.5 text-xs text-purple-700 border border-purple-200 bg-white px-2.5 py-1.5 rounded-md hover:bg-purple-50 hover:text-purple-800 transition">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Ver comprobantes ↗
        </button>
        <button (click)="closePaymentPlansOffcanvas()"
          class="p-2 text-gray-400 hover:text-gray-600 hover:bg-white rounded-lg transition-colors duration-150">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Contenido del offcanvas -->
    <div class="h-full overflow-y-auto pb-20" *ngIf="selectedParticipant">

      <!-- Resumen financiero del participante -->
      <div class="p-6 bg-gray-50 border-b border-gray-200">
        <h4 class="text-sm font-medium text-gray-700 mb-4">Resumen Financiero</h4>
        <div class="grid grid-cols-2 gap-4">
          <div class="bg-white p-4 rounded-lg border border-gray-200">
            <div class="text-2xl font-bold text-blue-600">{{
              formatCurrencyValue(getParticipantTotalAmount(selectedParticipant.paymentPlans)) }}</div>
            <div class="text-xs text-gray-500 mt-1">Total a Pagar</div>
            <div *ngIf="isInternationalEnrollment" class="text-xs text-purple-500 mt-1">≈ {{
              calculateCOPEquivalent(getParticipantTotalAmount(selectedParticipant.paymentPlans)) }}</div>
          </div>
          <div class="bg-white p-4 rounded-lg border border-gray-200">
            <div class="text-2xl font-bold text-green-600">{{
              getParticipantCompletedPayments(selectedParticipant.paymentPlans) }}/{{
              selectedParticipant.paymentPlans?.length || 0 }}</div>
            <div class="text-xs text-gray-500 mt-1">Cuotas Pagadas</div>
          </div>
          <div class="bg-white p-4 rounded-lg border border-gray-200">
            <div class="text-2xl font-bold text-orange-600">{{
              formatCurrencyValue(getParticipantPendingPlansAmount(selectedParticipant.paymentPlans)) }}</div>
            <div class="text-xs text-gray-500 mt-1">Saldo Pendiente</div>
            <div *ngIf="isInternationalEnrollment" class="text-xs text-purple-500 mt-1">≈ {{
              calculateCOPEquivalent(getParticipantPendingPlansAmount(selectedParticipant.paymentPlans)) }}</div>
          </div>
          <div class="bg-white p-4 rounded-lg border border-gray-200">
            <div class="text-2xl font-bold text-red-600">{{
              formatCurrencyValue(getParticipantOverdueAmount(selectedParticipant.paymentPlans)) }}</div>
            <div class="text-xs text-gray-500 mt-1">Vencido</div>
            <div *ngIf="isInternationalEnrollment" class="text-xs text-purple-500 mt-1">≈ {{
              calculateCOPEquivalent(getParticipantOverdueAmount(selectedParticipant.paymentPlans)) }}</div>
          </div>
          <div class="bg-white p-4 rounded-lg border border-rose-200 col-span-2">
            <div class="text-2xl font-bold text-rose-700">{{
              formatCurrencyValue(getParticipantCastigadoAmount(selectedParticipant.paymentPlans)) }}</div>
            <div class="text-xs text-gray-500 mt-1">Cartera Castigada</div>
            <div *ngIf="isInternationalEnrollment" class="text-xs text-purple-500 mt-1">≈ {{
              calculateCOPEquivalent(getParticipantCastigadoAmount(selectedParticipant.paymentPlans)) }}</div>
          </div>
        </div>

        <!-- Barra de progreso -->
        <div class="mt-4">
          <div class="flex justify-between text-sm text-gray-600 mb-2">
            <span>Progreso de Pagos</span>
            <span>{{ getParticipantCompletionPercentage(selectedParticipant.paymentPlans) | number:'1.0-1' }}%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-3">
            <div class="bg-gradient-to-r from-green-400 to-green-600 h-3 rounded-full transition-all duration-300"
              [style.width.%]="getParticipantCompletionPercentage(selectedParticipant.paymentPlans)">
            </div>
          </div>
        </div>
      </div>

      <!-- Observaciones de la inscripción del participante (siempre visible) -->
      <div *ngIf="selectedParticipant?.enrollment" class="px-6 pt-4">
        <div class="bg-amber-50 p-4 rounded-lg border border-amber-200">
          <p class="text-xs font-semibold text-amber-800 mb-1 flex items-center gap-1">
            <svg class="w-3.5 h-3.5 text-amber-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Observaciones de la Inscripción
          </p>
          <p class="text-xs text-amber-900" *ngIf="selectedParticipant?.enrollment?.observations">{{ selectedParticipant.enrollment.observations }}</p>
          <p class="text-xs text-amber-700 italic" *ngIf="!selectedParticipant?.enrollment?.observations">Sin observaciones</p>
        </div>
      </div>

      <!-- Lista de planes de pago - Simplificado -->
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h4 class="text-sm font-medium text-gray-700">Detalle de Cuotas</h4>
          <div *ngIf="!isEnrollmentCancelled" class="flex gap-2">
            <button *ngIf="isParticipantPunishMode" (click)="selectAllParticipantPlans()"
              class="text-xs text-blue-600 hover:text-blue-800 font-medium hover:underline">
              {{ selectedParticipantPlanIds.length === selectedParticipant.paymentPlans?.length ? 'Deseleccionar Todo' :
              'Seleccionar Todo' }}
            </button>
            <button (click)="toggleParticipantPunishMode()"
              class="inline-flex items-center gap-2 text-xs border border-red-200 text-red-700 px-2 py-1 rounded-md shadow-sm hover:bg-red-50 transition"
              [ngClass]="{'bg-red-100 ring-2 ring-red-400': isParticipantPunishMode}">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              {{ isParticipantPunishMode ? 'Cancelar' : 'Gestionar Castigo' }}
            </button>
          </div>
        </div>

        <!-- Panel de Gestión de Castigo (Participante) -->
        <div *ngIf="isParticipantPunishMode"
          class="mb-4 p-3 bg-red-50 rounded-lg border border-red-200 shadow-sm animate-fade-in">
          <p class="text-xs text-red-800 font-bold mb-2">Modo de Castigo Manual</p>
          <div class="space-y-2 mb-3">
            <input [(ngModel)]="participantPunishReason" type="text"
              class="w-full text-xs rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
              placeholder="Razón del cambio (Requerido)">
            <input [(ngModel)]="participantPunishNotes" type="text"
              class="w-full text-xs rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
              placeholder="Notas adicionales (Opcional)">
          </div>
          <div class="flex items-center justify-between">
            <span class="text-xs font-bold text-red-600">{{ selectedParticipantPlanIds.length }} seleccionadas</span>
            <div class="flex gap-2">
              <button (click)="executeParticipantPunishAction('punish')"
                [disabled]="selectedParticipantPlanIds.length === 0 || !participantPunishReason"
                class="px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50 text-xs">Castigar</button>
              <button (click)="executeParticipantPunishAction('unpunish')"
                [disabled]="selectedParticipantPlanIds.length === 0 || !participantPunishReason"
                class="px-2 py-1 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50 disabled:opacity-50 text-xs">Descastigar</button>
            </div>
          </div>
        </div>

        <!-- 🆕 Stats de cuotas del participante -->
        <div *ngIf="selectedParticipant.paymentPlans?.length" class="mb-4">
          <app-installment-stats [plans]="selectedParticipant.paymentPlans" variant="card"
            title="Estado de cuotas del participante"></app-installment-stats>
        </div>

        <div class="space-y-3" *ngIf="selectedParticipant.paymentPlans?.length; else noPaymentPlans"
             cdkDropList
             [cdkDropListDisabled]="!isSuperAdmin"
             (cdkDropListDropped)="onParticipantPlanDrop($event)">
          <div *ngFor="let plan of selectedParticipant.paymentPlans"
            cdkDrag
            [cdkDragData]="plan"
            [cdkDragDisabled]="!isSuperAdmin"
            cdkDragLockAxis="y"
            class="bg-white border rounded-lg p-4 hover:shadow-md transition-shadow duration-200 relative" [ngClass]="{
                 'ring-2 ring-red-200 bg-red-50': isPaymentOverdue(plan) && !plan.isPunished && !isParticipantPlanSelected(plan.id),
                 'ring-2 ring-red-300 bg-red-100': plan.isPunished && !isParticipantPlanSelected(plan.id),
                 'ring-2 ring-red-500 bg-red-50': isParticipantPlanSelected(plan.id)
               }" (click)="isParticipantPunishMode ? toggleParticipantPlanSelection(plan.id) : null"
            [class.cursor-pointer]="isParticipantPunishMode">

            <!-- 🆕 Handle de drag flotante en la esquina superior izquierda (solo super-admin) -->
            <div *ngIf="isSuperAdmin" cdkDragHandle
                 class="absolute top-2 left-2 z-10 p-1 text-gray-300 hover:text-gray-600 cursor-grab active:cursor-grabbing"
                 title="Arrastrar para reordenar"
                 (click)="$event.stopPropagation()">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7 4a1 1 0 100 2 1 1 0 000-2zM7 9a1 1 0 100 2 1 1 0 000-2zM7 14a1 1 0 100 2 1 1 0 000-2zM13 4a1 1 0 100 2 1 1 0 000-2zM13 9a1 1 0 100 2 1 1 0 000-2zM13 14a1 1 0 100 2 1 1 0 000-2z"/>
              </svg>
            </div>

            <div *ngIf="isParticipantPunishMode" class="absolute top-2 right-2 z-10">
              <input type="checkbox" [checked]="isParticipantPlanSelected(plan.id)"
                [disabled]="plan.paymentStatus === 'PAID'"
                class="rounded text-red-600 focus:ring-red-500 w-5 h-5 disabled:opacity-50 disabled:cursor-not-allowed">
            </div>

            <div class="space-y-3">
              <!-- Header con información básica -->
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <span class="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold"
                    [ngClass]="{
                          'bg-green-100 text-green-600': plan.paymentStatus === 'PAID' && !plan.isPunished,
                          'bg-yellow-100 text-yellow-600': plan.paymentStatus === 'PENDING' && !plan.isPunished,
                          'bg-red-100 text-red-600': (plan.paymentStatus === 'OVERDUE' && !plan.isPunished) || plan.isPunished,
                          'bg-blue-100 text-blue-600': plan.paymentStatus === 'LINK_GENERATED' && !plan.isPunished
                        }">
                    #{{ plan.installmentNumber }}
                  </span>
                  <div class="flex-1">
                    <div class="flex items-center gap-2">
                      <div>
                        <div class="text-sm font-medium text-gray-900">{{ formatCurrencyValue(plan.amountToPay) }}</div>
                        <!-- ID interno de la cuota (CorporatePaymentPlan.Id) — útil para soporte/queries -->
                        <div class="text-[10px] font-mono font-semibold text-gray-500 tabular-nums mt-0.5"
                          title="ID interno de la cuota corporativa">
                          ID #{{ plan.id }}
                        </div>
                        <div *ngIf="isInternationalEnrollment && plan.amountToPay" class="text-xs text-purple-500">
                          ≈ {{ calculatePlanCOPEquivalent(plan, plan.amountToPay) }}
                          <span class="ml-1 text-[10px] text-gray-400">(TRM {{ formatPlanExchangeRate(plan) }})</span>
                        </div>
                      </div>
                      <!-- 🆕 Indicador de cartera castigada -->
                      <span *ngIf="plan.isPunished"
                        class="px-2 py-0.5 text-xs font-bold bg-red-200 text-red-800 rounded-full flex items-center gap-1">
                        <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                        Castigada
                      </span>
                    </div>
                    <div class="text-xs text-gray-500">{{ plan.dueDate | date:'mediumDate' }}</div>
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <span class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full" [ngClass]="{
                          'bg-green-100 text-green-800': plan.paymentStatus === 'PAID',
                          'bg-yellow-100 text-yellow-800': plan.paymentStatus === 'PENDING',
                          'bg-red-100 text-red-800': plan.paymentStatus === 'OVERDUE',
                          'bg-blue-100 text-blue-800': plan.paymentStatus === 'LINK_GENERATED'
                        }">
                    {{ getPaymentStatusLabel(plan.paymentStatus) }}
                  </span>
                  <a *ngIf="plan.paymentStatus !== 'PAID' && !isEnrollmentCancelled" [routerLink]="['/dashboard/income-receipts/new']"
                    [queryParams]="{participantId: selectedParticipant.enrollment?.participant?.id, companyId: details.company?.id, projectId: details.project?.id, corporateEnrollmentId: details.id, installmentNumber: plan.installmentNumber, isParticipantCorporatePayment: true}"
                    class="text-blue-600 hover:text-blue-800 p-1 rounded-md hover:bg-blue-50">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                    </svg>
                  </a>
                  <!-- 🔐 Editar (solo super-admin) -->
                  <button *ngIf="isSuperAdmin" (click)="openAdminMenu(plan)"
                    title="Acciones admin sobre esta cuota corporativa"
                    class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300 transition-colors">
                    <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                    Editar
                  </button>
                </div>
              </div>

              <!-- Observaciones de la cuota (siempre visible) -->
              <div *ngIf="!plan.isPunished"
                class="bg-blue-50 p-3 rounded-lg border border-blue-200">
                <h5 class="text-xs font-bold text-blue-600 uppercase mb-2 flex items-center gap-1">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                  Observaciones
                </h5>
                <p *ngIf="plan.observations" class="text-xs text-blue-900">{{ plan.observations }}</p>
                <p *ngIf="!plan.observations" class="text-xs text-blue-400 italic">Sin observaciones</p>
              </div>

              <!-- 🆕 Información de Cartera Castigada -->
              <div *ngIf="plan.isPunished" class="bg-red-50 p-3 rounded-lg border border-red-200">
                <h5 class="text-xs font-bold text-red-800 mb-2 flex items-center gap-1">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Cartera Castigada
                </h5>
                <div class="grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <p class="text-red-600 font-medium">Tipo:</p>
                    <p class="text-red-900">{{ getMovementTypeLabel(plan.movementType) }}</p>
                  </div>
                  <div *ngIf="plan.movementDate">
                    <p class="text-red-600 font-medium">Fecha:</p>
                    <p class="text-red-900">{{ plan.movementDate | date:'shortDate' }}</p>
                  </div>
                </div>
                <div *ngIf="plan.observations" class="mt-2 p-2 bg-red-100 rounded text-xs">
                  <p class="text-red-600 font-medium">📝 Observaciones:</p>
                  <p class="text-red-900">{{ plan.observations }}</p>
                </div>
              </div>

              <!-- Payment Link Manager para Participante -->
              <div *ngIf="plan.paymentLinkUrl" class="bg-gray-50 p-3 rounded-lg">
                <app-payment-link-manager [paymentLinkUrl]="plan.paymentLinkUrl" [paymentLinkId]="plan.paymentLinkId"
                  [paymentLinkWompiId]="plan.paymentLinkWompiId" [isActive]="plan.paymentLinkActive !== false"
                  [showDeactivateButton]="true" [size]="'sm'"
                  (paymentLinkDeactivated)="onParticipantPaymentLinkDeactivated()">
                </app-payment-link-manager>
              </div>

              <!-- Comprobantes de Ingreso del Participante -->
              <div *ngIf="(plan.incomeReceipts && plan.incomeReceipts.length > 0) || plan.paymentLinkId"
                class="mt-4 pt-4 border-t border-gray-200">
                <h5 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Comprobantes ({{ plan.incomeReceipts.length }})
                </h5>

                <!-- Tabs de comprobantes (participante) -->
                <div class="mb-3 border-b border-gray-200">
                  <nav class="flex gap-4">
                    <button (click)="setParticipantPlanTab(plan.id, 'active')"
                      class="pb-2 text-xs font-medium border-b-2 transition-colors"
                      [ngClass]="getParticipantPlanTab(plan.id) === 'active' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                      Activos
                      <span class="ml-1 bg-blue-100 text-blue-600 py-0.5 px-1.5 rounded-full text-xs">{{ getActiveReceipts(plan).length }}</span>
                    </button>
                    <button *ngIf="getCancelledReceipts(plan).length > 0"
                      (click)="setParticipantPlanTab(plan.id, 'cancelled')"
                      class="pb-2 text-xs font-medium border-b-2 transition-colors"
                      [ngClass]="getParticipantPlanTab(plan.id) === 'cancelled' ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                      Anulados
                      <span class="ml-1 bg-red-100 text-red-600 py-0.5 px-1.5 rounded-full text-xs">{{ getCancelledReceipts(plan).length }}</span>
                    </button>
                    <button *ngIf="plan.paymentLinkId"
                      (click)="setParticipantPlanTab(plan.id, 'emails'); loadEmailsForPlan(plan)"
                      class="pb-2 text-xs font-medium border-b-2 transition-colors"
                      [ngClass]="getParticipantPlanTab(plan.id) === 'emails' ? 'border-violet-500 text-violet-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
                      <svg class="w-3 h-3 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      Emails
                      <span *ngIf="hasEmails(plan)" class="ml-1 bg-violet-100 text-violet-600 py-0.5 px-1.5 rounded-full text-xs">{{ getEmailsForPlan(plan).length }}</span>
                    </button>
                  </nav>
                </div>

                <!-- Comprobantes activos (participante) -->
                <div *ngIf="getParticipantPlanTab(plan.id) === 'active'" class="space-y-2">
                  <div *ngFor="let receipt of getActiveReceipts(plan)"
                    class="p-3 rounded-lg shadow-sm relative overflow-hidden bg-white border border-gray-200">
                    <div class="relative z-10">
                    <div class="flex justify-between items-start mb-2">
                      <div>
                        <p class="text-sm font-bold mb-1 text-gray-900">{{ receipt.concept }}</p>
                        <div class="space-y-0.5">
                          <p class="text-xs text-gray-500 font-medium flex items-center gap-1">
                            <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            Creación: {{ receipt.createdAt | date:'mediumDate' }}
                          </p>
                          <p class="text-xs text-gray-500 font-medium flex items-center gap-1">
                            <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Pago:
                            <span *ngIf="receipt.transactionDate">{{ receipt.transactionDate | date:'mediumDate'
                              }}</span>
                            <span *ngIf="!receipt.transactionDate" class="text-gray-400 italic">No disponible</span>
                          </p>
                        </div>
                      </div>
                      <span class="text-xs font-medium px-2 py-1 rounded-full ml-2"
                        [ngClass]="receipt.isManualPayment ? 'bg-amber-100 text-amber-800' : 'bg-green-100 text-green-800'">
                        {{ receipt.isManualPayment ? 'Manual' : 'Automático' }}
                      </span>
                    </div>

                    <!-- 🆕 Información de Tasa de Cambio (si aplica) -->
                    <div *ngIf="hasReceiptExchangeRate(receipt)"
                      class="bg-purple-50 p-2 rounded-lg border-l-4 border-purple-400 mb-2">
                      <h6 class="text-xs font-semibold mb-1 text-purple-800 flex items-center gap-1">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 8c-1.657 0-3 .672-3 1.5S10.343 11 12 11s3-.672 3-1.5S13.657 8 12 8zm0 8c-1.657 0-3 .672-3 1.5S10.343 19 12 19s3-.672 3-1.5S13.657 16 12 16zm0-4c-1.657 0-3 .672-3 1.5S10.343 15 12 15s3-.672 3-1.5S13.657 12 12 12z" />
                        </svg>
                        Tasa de Cambio
                      </h6>
                      <div class="grid grid-cols-2 gap-1 text-xs">
                        <div>
                          <p class="text-purple-600 font-medium">Moneda:</p>
                          <p class="text-purple-900 font-semibold">{{ receipt.currencyCode }}</p>
                        </div>
                        <div>
                          <p class="text-purple-600 font-medium">Tasa (TRM):</p>
                          <p class="text-purple-900 font-semibold">{{ receipt.exchangeRate | number:'1.2-4' }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="mt-2 grid grid-cols-3 gap-2">
                      <div>
                        <p class="text-xs text-gray-500">Bruto</p>
                        <p class="text-sm font-medium text-yellow-700">{{ formatCurrencyValue(receipt.grossAmount,
                          receipt.currencySymbol, receipt.currencyCode) }}</p>
                        <p *ngIf="hasReceiptExchangeRate(receipt)" class="text-xs text-purple-500">≈ {{
                          getReceiptCOPEquivalent(receipt, receipt.grossAmount) }}</p>
                      </div>
                      <div>
                        <p class="text-xs text-gray-500">Descuentos</p>
                        <p class="text-sm font-medium text-red-700">{{ formatCurrencyValue(receipt.totalFees,
                          receipt.currencySymbol, receipt.currencyCode) }}</p>
                        <p *ngIf="hasReceiptExchangeRate(receipt)" class="text-xs text-purple-500">≈ {{
                          getReceiptCOPEquivalent(receipt, receipt.totalFees) }}</p>
                      </div>
                      <div>
                        <p class="text-xs text-gray-500">Neto</p>
                        <p class="text-sm font-medium text-green-700">{{ formatCurrencyValue(receipt.netAmount,
                          receipt.currencySymbol, receipt.currencyCode) }}</p>
                        <p *ngIf="hasReceiptExchangeRate(receipt)" class="text-xs text-purple-500">≈ {{
                          getReceiptCOPEquivalent(receipt, receipt.netAmount) }}</p>
                      </div>
                      <div>
                        <p class="text-xs text-gray-500">Método</p>
                        <p class="text-sm text-gray-700">{{ receipt.paymentMethod?.name || 'N/A' }}</p>
                      </div>
                      <div>
                        <p class="text-xs text-gray-500">Comprobante</p>
                        <a [routerLink]="['/dashboard/income-receipts/view', receipt.id]" target="_blank"
                          class="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                          </svg>
                          Ver
                        </a>
                      </div>
                    </div>
                    <!-- Observaciones del comprobante (siempre visible) -->
                    <div class="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                      <p class="text-xs font-medium text-blue-600 mb-1 flex items-center gap-1">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        Observaciones:
                      </p>
                      <p *ngIf="receipt.observations" class="text-xs text-blue-900">{{ receipt.observations }}</p>
                      <p *ngIf="!receipt.observations" class="text-xs text-blue-400 italic">Sin observaciones</p>
                    </div>
                    </div>
                  </div>
                  <div *ngIf="getActiveReceipts(plan).length === 0" class="text-center py-3 text-gray-400 text-xs">
                    No hay comprobantes activos
                  </div>
                </div>

                <!-- Comprobantes anulados (participante) -->
                <div *ngIf="getParticipantPlanTab(plan.id) === 'cancelled'" class="space-y-2">
                  <div *ngFor="let receipt of getCancelledReceipts(plan)"
                    class="p-3 rounded-lg shadow-sm relative overflow-hidden bg-red-50 border border-red-200">
                    <div class="absolute -inset-[25%] pointer-events-none" style="transform: rotate(-30deg);">
                      <div class="flex flex-col items-center justify-center h-full gap-8">
                        <span class="text-red-400/15 text-4xl font-black tracking-[0.2em] select-none whitespace-nowrap">ANULADO</span>
                        <span class="text-red-400/15 text-4xl font-black tracking-[0.2em] select-none whitespace-nowrap">ANULADO</span>
                      </div>
                    </div>
                    <div class="relative z-10">
                      <div class="flex justify-between items-start mb-2">
                        <div>
                          <p class="text-sm font-bold mb-1 text-red-800 line-through">{{ receipt.concept }}</p>
                          <p *ngIf="receipt.cancelledAt" class="text-xs text-red-600">Anulado: {{ receipt.cancelledAt | date:'mediumDate' }}</p>
                          <p *ngIf="receipt.cancellationReason" class="text-xs text-red-600">Motivo: {{ receipt.cancellationReason }}</p>
                        </div>
                        <span class="text-xs font-medium px-2 py-1 rounded-full bg-red-200 text-red-800">Anulado</span>
                      </div>
                      <div class="mt-2 grid grid-cols-3 gap-2">
                        <div>
                          <p class="text-xs text-gray-500">Bruto</p>
                          <p class="text-sm font-medium text-gray-500 line-through">{{ formatCurrencyValue(receipt.grossAmount, receipt.currencySymbol, receipt.currencyCode) }}</p>
                        </div>
                        <div>
                          <p class="text-xs text-gray-500">Neto</p>
                          <p class="text-sm font-medium text-gray-500 line-through">{{ formatCurrencyValue(receipt.netAmount, receipt.currencySymbol, receipt.currencyCode) }}</p>
                        </div>
                        <div>
                          <p class="text-xs text-gray-500">Comprobante</p>
                          <a [routerLink]="['/dashboard/income-receipts/view', receipt.id]" target="_blank"
                            class="text-blue-600 hover:text-blue-800 text-sm font-medium">Ver</a>
                        </div>
                      </div>
                      <div *ngIf="receipt.observations" class="mt-3 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                        <p class="text-xs font-medium text-yellow-700 mb-1">Observaciones:</p>
                        <p class="text-xs text-yellow-900">{{ receipt.observations }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Emails enviados (participante) -->
                <ng-container *ngIf="getParticipantPlanTab(plan.id) === 'emails'">
                  <!-- Loading -->
                  <div *ngIf="isEmailsLoading(plan)" class="flex justify-center py-4">
                    <svg class="animate-spin h-6 w-6 text-violet-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </div>
                  <!-- Empty state -->
                  <div *ngIf="!isEmailsLoading(plan) && !hasEmails(plan)" class="text-center py-4">
                    <svg class="w-8 h-8 text-gray-300 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <p class="text-xs text-gray-400">No se han enviado emails para este plan</p>
                  </div>
                  <!-- Email list -->
                  <div *ngIf="!isEmailsLoading(plan) && hasEmails(plan)" class="space-y-2">
                    <div *ngFor="let email of getEmailsForPlan(plan)"
                      class="p-3 rounded-lg border" [ngClass]="email.isSuccess ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'">
                      <div class="flex justify-between items-start mb-1">
                        <div class="flex items-center gap-2">
                          <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium"
                            [ngClass]="email.isSuccess ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                            {{ email.isSuccess ? 'Enviado' : 'Error' }}
                          </span>
                          <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-violet-100 text-violet-800">
                            {{ email.emailType }}
                          </span>
                        </div>
                        <span class="text-xs text-gray-500">{{ emailLogService.formatDateTime(email.sentAt) }}</span>
                      </div>
                      <p class="text-xs text-gray-700 mt-1">
                        <span class="font-medium">Para:</span> {{ email.recipientName ? email.recipientName + ' &lt;' + email.recipientEmail + '&gt;' : email.recipientEmail }}
                      </p>
                      <p class="text-xs text-gray-600 mt-0.5">
                        <span class="font-medium">Asunto:</span> {{ email.subject }}
                      </p>
                      <p *ngIf="!email.isSuccess && email.errorMessage" class="text-xs text-red-600 mt-1">
                        <span class="font-medium">Error:</span> {{ email.errorMessage }}
                      </p>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Empty state para plan sin comprobantes ni emails -->
              <div *ngIf="(!plan.incomeReceipts || plan.incomeReceipts.length === 0) && !plan.paymentLinkId"
                class="mt-4 pt-4 border-t border-gray-200">
                <p class="text-center text-xs text-gray-400 py-2">Sin comprobantes de ingreso</p>
              </div>

              <!-- Devoluciones relacionadas con este plan de participante -->
              <div *ngIf="hasRefundsForParticipantPlan(plan)" class="mt-4 pt-4 border-t border-gray-200">
                <h5 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m5 8a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  Devoluciones ({{ getRefundsForParticipantPlan(plan).length }})
                </h5>
                <div class="space-y-2">
                  <div *ngFor="let refund of getRefundsForParticipantPlan(plan)"
                    class="bg-red-50 border border-red-200 rounded-lg p-3">
                    <div class="flex justify-between items-start mb-2">
                      <div>
                        <p class="text-sm font-medium text-gray-900">
                          <a [routerLink]="['/refund-vouchers/view', refund.id]" target="_blank"
                            class="text-blue-600 hover:text-blue-800">
                            {{ refund.documentNumber }}
                          </a>
                        </p>
                        <p class="text-xs text-gray-500">{{ refund.documentDate | date:'shortDate' }}</p>
                      </div>
                      <span class="text-xs font-medium px-2 py-1 rounded-full" [ngClass]="{
                              'bg-green-100 text-green-800': refund.status === 'Completed',
                              'bg-amber-100 text-amber-800': refund.status === 'Pending',
                              'bg-blue-100 text-blue-800': refund.status === 'Approved',
                              'bg-purple-100 text-purple-800': refund.status === 'Processing'
                            }">
                        {{ refund.statusDescription }}
                      </span>
                    </div>
                    <div class="text-sm">
                      <p class="text-gray-600">
                        <span class="font-medium">Monto devuelto:</span>
                        {{ formatRefundAmount(refund.totalRefundedForPlan, refund) }}
                      </p>
                      <p *ngIf="refund.concept" class="text-gray-500 text-xs mt-1">{{ refund.concept }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noPaymentPlans>
          <div class="text-center py-8 text-gray-500">
            <p>No hay planes de pago configurados</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- 🆕 Ingresos Generales (Sin Plan de Pago) del acuerdo corporativo -->
    <section class="pt-8 mt-8 border-t border-gray-200">
      <!-- Encabezado -->
      <div class="mb-6">
        <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div>
            <h2 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
              <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" stroke-width="2"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
              Ingresos Generales
            </h2>
            <p class="text-sm text-gray-500 mt-1">
              Pagos por servicios adicionales, certificados y otros conceptos (no vinculados a un plan de pagos)
              <span *ngIf="generalIncomeReceipts.length > 0" class="ml-2 text-purple-600 font-medium">
                • {{ generalIncomeReceipts.length }} comprobante(s) registrado(s)
              </span>
            </p>
          </div>

          <!-- Botón para agregar nuevo ingreso general -->
          <div class="flex gap-3" *ngIf="details?.project?.id">
            <a [routerLink]="['/dashboard/income-receipts/new']"
              [queryParams]="{ projectId: details.project.id, corporateEnrollmentId: details.agreementId }"
              class="inline-flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition shadow-sm">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path>
              </svg>
              Agregar Ingreso
            </a>
          </div>
        </div>

        <!-- Resumen financiero -->
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6" *ngIf="generalIncomeReceipts.length > 0">
          <div class="bg-purple-50 p-4 rounded-xl border border-purple-200">
            <p class="text-xs font-medium text-purple-600 mb-1">Total Ingresos</p>
            <p class="text-lg font-bold text-purple-800">
              {{ getTotalGeneralIncome() | currency }}
            </p>
          </div>
          <div class="bg-blue-50 p-4 rounded-xl border border-blue-200">
            <p class="text-xs font-medium text-blue-600 mb-1">Comprobantes</p>
            <p class="text-lg font-bold text-blue-800">{{ generalIncomeReceipts.length }}</p>
          </div>
          <div class="bg-green-50 p-4 rounded-xl border border-green-200">
            <p class="text-xs font-medium text-green-600 mb-1">Último Pago</p>
            <p class="text-sm font-bold text-green-800">
              {{ generalIncomeReceipts[0]?.createdAt | date:'shortDate' }}
            </p>
          </div>
        </div>
      </div>

      <!-- Lista de ingresos generales -->
      <div *ngIf="generalIncomeReceipts.length > 0" class="space-y-4">
        <div *ngFor="let receipt of generalIncomeReceipts"
          class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow">

          <!-- Header del comprobante -->
          <div class="flex justify-between items-start mb-4">
            <div class="flex-1">
              <div class="flex flex-wrap items-center gap-3 mb-2">
                <h3 class="text-lg font-semibold text-gray-900">{{ receipt.concept }}</h3>
                <span class="text-xs font-medium px-2 py-1 rounded-full"
                  [ngClass]="receipt.isManualPayment ? 'bg-amber-100 text-amber-800' : 'bg-green-100 text-green-800'">
                  {{ receipt.isManualPayment ? 'Manual' : 'Automático' }}
                </span>
                <span class="text-xs font-medium px-2 py-1 rounded-full bg-indigo-100 text-indigo-800">
                  {{ getReceiptPayerType(receipt) }}
                </span>
              </div>
              <div class="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                <span class="flex items-center gap-1">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                  </svg>
                  {{ getReceiptPayerLabel(receipt) }}
                </span>
                <span class="flex items-center gap-1">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                    </path>
                  </svg>
                  {{ receipt.createdAt | date:'medium' }}
                </span>
                <span class="flex items-center gap-1">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
                    </path>
                  </svg>
                  {{ receipt.paymentMethod?.name || 'N/A' }}
                </span>
                <span *ngIf="receipt.referenceNumber" class="flex items-center gap-1">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path>
                  </svg>
                  Ref: {{ receipt.referenceNumber }}
                </span>
              </div>
            </div>

            <!-- Monto destacado -->
            <div class="text-right">
              <p class="text-xs text-gray-500 mb-1">Monto Neto</p>
              <p class="text-2xl font-bold text-green-600">
                {{ formatCurrencyValue(receipt.netAmount, receipt.currencySymbol, receipt.currencyCode) }}
              </p>
            </div>
          </div>

          <!-- Información de Tasa de Cambio (si aplica) -->
          <div *ngIf="hasReceiptExchangeRate(receipt)"
            class="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-400 mb-4">
            <h4 class="text-sm font-semibold mb-3 text-purple-800 flex items-center gap-2">
              💱 Información de Tasa de Cambio
            </h4>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div>
                <p class="text-xs text-purple-600 font-medium">Moneda Original:</p>
                <p class="text-purple-900 font-semibold">{{ receipt.currencyCode }}</p>
              </div>
              <div>
                <p class="text-xs text-purple-600 font-medium">Tasa de Cambio:</p>
                <p class="text-purple-900 font-semibold">{{ receipt.exchangeRate | number:'1.2-4' }}</p>
                <p class="text-xs text-purple-500" *ngIf="receipt.exchangeRateEffectiveDate">
                  {{ receipt.exchangeRateEffectiveDate | date:'short' }}
                </p>
              </div>
              <div>
                <p class="text-xs text-purple-600 font-medium">Monto Bruto (COP):</p>
                <p class="text-purple-900 font-semibold">{{ getReceiptCOPEquivalent(receipt, receipt.grossAmount) }}</p>
              </div>
              <div>
                <p class="text-xs text-purple-600 font-medium">Monto Neto (COP):</p>
                <p class="text-purple-900 font-semibold">{{ getReceiptCOPEquivalent(receipt, receipt.netAmount) }}</p>
              </div>
            </div>
            <p class="text-xs text-purple-400 mt-2">* Valores calculados con la tasa registrada al momento del pago</p>
          </div>

          <!-- Detalles financieros -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
            <div>
              <p class="text-xs text-gray-500 mb-1">Monto Bruto</p>
              <p class="text-sm font-semibold text-yellow-700">
                {{ formatCurrencyValue(receipt.grossAmount, receipt.currencySymbol, receipt.currencyCode) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 mb-1">Descuentos</p>
              <p class="text-sm font-semibold text-red-700">
                {{ formatCurrencyValue(receipt.totalFees, receipt.currencySymbol, receipt.currencyCode) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 mb-1">Monto Neto</p>
              <p class="text-sm font-semibold text-green-700">
                {{ formatCurrencyValue(receipt.netAmount, receipt.currencySymbol, receipt.currencyCode) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 mb-1">Banco</p>
              <p class="text-sm text-gray-700">{{ receipt.bank?.bankName || 'N/A' }}</p>
            </div>
          </div>

          <!-- Observaciones (si existen) -->
          <div *ngIf="receipt.observations" class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p class="text-xs font-medium text-blue-600 mb-1">📝 Observaciones:</p>
            <p class="text-sm text-blue-900">{{ receipt.observations }}</p>
          </div>

          <!-- Descuentos aplicados (si existen) -->
          <div *ngIf="receipt.feeDetails && receipt.feeDetails.length > 0" class="mb-4">
            <p class="text-xs font-medium text-gray-600 mb-2">💰 Descuentos Aplicados:</p>
            <div class="space-y-2">
              <div *ngFor="let fee of receipt.feeDetails"
                class="flex justify-between items-center p-2 bg-red-50 rounded border border-red-200">
                <div>
                  <p class="text-sm font-medium text-red-900">{{ fee.feeType?.name || 'Descuento' }}</p>
                  <p class="text-xs text-red-600">{{ fee.description }}</p>
                </div>
                <p class="text-sm font-bold text-red-700">-{{ fee.appliedAmount | currency }}</p>
              </div>
            </div>
          </div>

          <!-- Acción para ver comprobante completo -->
          <div class="pt-3 border-t border-gray-200">
            <a [routerLink]="['/income-receipts/view', receipt.id]" target="_blank"
              class="text-purple-600 hover:text-purple-800 text-sm font-medium inline-flex items-center gap-2 transition">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
              </svg>
              Ver comprobante completo
            </a>
          </div>
        </div>
      </div>

      <!-- Estado vacío -->
      <div *ngIf="generalIncomeReceipts.length === 0"
        class="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
        <svg class="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" stroke-width="1.5"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
          </path>
        </svg>
        <h3 class="text-lg font-semibold text-gray-700 mb-2">No hay ingresos generales registrados</h3>
        <p class="text-sm text-gray-500 mb-4">
          Los ingresos generales son pagos por servicios adicionales (certificados, constancias, etc.) que no están
          vinculados a un plan de pagos.
        </p>
        <a *ngIf="details?.project?.id" [routerLink]="['/dashboard/income-receipts/new']"
          [queryParams]="{ projectId: details.project.id, corporateEnrollmentId: details.agreementId }"
          class="inline-flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition shadow-sm">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path>
          </svg>
          Agregar Primer Ingreso
        </a>
      </div>
    </section>

    <!-- 🆕 Huella de auditoría: timeline de acciones del acuerdo corporativo -->
    <section *ngIf="agreementId" class="mt-8">
      <app-enrollment-audit-timeline [enrollmentId]="agreementId" mode="corporate"></app-enrollment-audit-timeline>
    </section>
  </div>
</div>

<!-- Modal de Confirmación de Cambio de Estado -->
<div *ngIf="showStatusConfirmationModal"
  class="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 transition-opacity duration-300"
  (click)="onStatusConfirmationCancelled()" (keydown.escape)="onStatusConfirmationCancelled()">
  <div
    class="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 overflow-hidden transform transition-all duration-300 scale-100"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="px-6 py-4 bg-gradient-to-r from-yellow-500 to-orange-500">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-white bg-opacity-20 rounded-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h3 class="text-lg font-bold text-white">{{ statusConfirmationConfig.title }}</h3>
      </div>
    </div>

    <!-- Body -->
    <div class="px-6 py-5">
      <p class="text-gray-700 text-sm whitespace-pre-line mb-4">{{ statusConfirmationConfig.message }}</p>

      <!-- Input de Razón (condicional) -->
      <div *ngIf="showReasonInput" class="mt-4">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          <span class="text-red-500">*</span> Razón del cambio:
        </label>
        <textarea [(ngModel)]="statusChangeReason" rows="3" placeholder="Ingresa la razón para este cambio de estado..."
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-sm resize-none transition-colors"></textarea>
        <p *ngIf="showReasonInput && !statusChangeReason.trim()" class="text-xs text-red-500 mt-1">
          Este campo es obligatorio
        </p>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
      <button (click)="onStatusConfirmationCancelled()"
        class="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium">
        {{ statusConfirmationConfig.cancelText }}
      </button>
      <button (click)="onStatusConfirmationConfirmed()" [disabled]="showReasonInput && !statusChangeReason.trim()"
        class="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed">
        {{ statusConfirmationConfig.confirmText }}
      </button>
    </div>
  </div>
</div>

<!-- Modal de Confirmación de Anulación -->
<div *ngIf="showCancellationModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title"
  role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"
      (click)="closeCancellationModal()"></div>

    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div
      class="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div
            class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <svg class="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Anular Inscripción Corporativa</h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                ¿Estás seguro de que deseas anular esta inscripción corporativa? Esta acción revertirá el estado,
                desactivará los planes de pago de la empresa y <strong>todos los participantes asociados</strong>.
              </p>
              <div class="mt-4">
                <label for="reason" class="block text-sm font-medium text-gray-700">Motivo de anulación *</label>
                <textarea id="reason" rows="3" [(ngModel)]="cancellationReason"
                  class="mt-1 shadow-sm focus:ring-red-500 focus:border-red-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="Describe el motivo de la anulación..."></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button type="button" [disabled]="!cancellationReason || isCancelling" (click)="confirmCancellation()"
          class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isCancelling ? 'Anulando...' : 'Confirmar Anulación' }}
        </button>
        <button type="button" (click)="closeCancellationModal()"
          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Confirmación: Toggle de Cobro Automático -->
<app-confirmation-modal [isVisible]="showAutoPaymentConfirmationModal" [config]="autoPaymentConfirmationConfig"
  (confirmed)="onAutoPaymentConfirmed()" (cancelled)="onAutoPaymentCancelled()">
</app-confirmation-modal>

<!-- 🔐 Modal de operaciones admin sobre cuota corporativa (permiso ENROLLMENTS_PAYMENT_PLAN_ADMIN_OPS) -->
<div *ngIf="adminModal.open && adminModal.plan"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
    <div class="flex items-start justify-between gap-3">
      <div>
        <h2 class="text-xl font-bold text-gray-900">
          <ng-container [ngSwitch]="adminModal.mode">
            <span *ngSwitchCase="'menu'">Editar cuota corporativa — Acciones disponibles</span>
            <span *ngSwitchCase="'renumber'">Renumerar cuota</span>
            <span *ngSwitchCase="'date'">Cambiar fecha de vencimiento</span>
            <span *ngSwitchCase="'delete'">Eliminar cuota</span>
            <span *ngSwitchCase="'status'">Cambiar estado</span>
            <span *ngSwitchCase="'attach'">Asociar comprobante de ingreso</span>
            <span *ngSwitchCase="'recalculate'">Recalcular monto pagado</span>
            <span *ngSwitchCase="'punish-remaining'">Castigar saldo restante</span>
          </ng-container>
        </h2>
        <p class="mt-1 text-xs text-gray-500">
          Cuota actual: <span class="font-semibold">#{{ adminModal.plan.installmentNumber }}</span>
          · Vence {{ adminModal.plan.dueDate | date:'dd/MM/yyyy' }}
          · {{ formatCurrencyValue(adminModal.plan.amountToPay) }}
        </p>
      </div>
      <button type="button" (click)="closeAdminModal()" class="rounded-full p-1 text-gray-400 hover:bg-gray-100">
        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>

    <!-- 🆕 GRILLA DE ACCIONES (cuando mode='menu') -->
    <div *ngIf="adminModal.mode === 'menu'" class="mt-5">
      <p class="text-sm text-gray-600 mb-3">Elegí qué querés hacer con esta cuota:</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <button type="button" (click)="selectAdminMode('recalculate')"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-emerald-300 hover:bg-emerald-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Recalcular monto pagado</span>
            <span class="block text-xs text-gray-500">Suma los recibos asociados y actualiza el estado.</span>
          </span>
        </button>

        <button type="button" (click)="selectAdminMode('status')"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-teal-300 hover:bg-teal-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-100 text-teal-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Cambiar estado</span>
            <span class="block text-xs text-gray-500">Forzar PAGADO / PARCIAL / PENDIENTE / etc.</span>
          </span>
        </button>

        <button type="button" (click)="selectAdminMode('attach')"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-purple-300 hover:bg-purple-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-purple-100 text-purple-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Asociar comprobante</span>
            <span class="block text-xs text-gray-500">Enganchar un IncomeReceipt existente por ID.</span>
          </span>
        </button>

        <button type="button" (click)="selectAdminMode('renumber')"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-amber-300 hover:bg-amber-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Renumerar</span>
            <span class="block text-xs text-gray-500">Cambiar el número de cuota (#1, #2…).</span>
          </span>
        </button>

        <button type="button" (click)="selectAdminMode('date')"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-sky-300 hover:bg-sky-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sky-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Cambiar fecha</span>
            <span class="block text-xs text-gray-500">Modificar la fecha de vencimiento.</span>
          </span>
        </button>

        <button type="button" (click)="selectAdminMode('delete')"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-rose-300 hover:bg-rose-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-rose-100 text-rose-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Eliminar cuota</span>
            <span class="block text-xs text-gray-500">Soft delete (archivar con audit trail).</span>
          </span>
        </button>

        <!-- Castigar saldo restante: sólo tiene sentido si hay saldo > 0 (parcial). -->
        <button type="button" (click)="selectAdminMode('punish-remaining')"
          *ngIf="adminModal.plan && (adminModal.plan.amountToPay - adminModal.plan.amountPaid) > 0 && !adminModal.plan.isPunished && adminModal.plan.paymentStatus !== 'PAID'"
          class="flex items-start gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left hover:border-orange-300 hover:bg-orange-50 transition-colors">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-orange-100 text-orange-700">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0L3.16 16.25A2 2 0 005 19z"/></svg>
          </span>
          <span>
            <span class="block text-sm font-semibold text-gray-900">Castigar saldo restante</span>
            <span class="block text-xs text-gray-500">Cierra la cuota al monto pagado y crea una nueva castigada por el saldo.</span>
          </span>
        </button>
      </div>
    </div>

    <!-- Botón "← Volver" cuando estamos en un modo específico -->
    <div *ngIf="adminModal.mode && adminModal.mode !== 'menu'" class="mt-3">
      <button type="button" (click)="backToAdminMenu()"
        class="inline-flex items-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-800">
        <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
        Volver a acciones
      </button>
    </div>

    <!-- 🆕 Recalcular monto pagado -->
    <div *ngIf="adminModal.mode === 'recalculate'" class="mt-4">
      <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900">
        <p class="font-semibold">¿Qué va a pasar?</p>
        <ul class="mt-2 list-disc pl-5 space-y-1 text-xs">
          <li>Se suman los <strong>recibos activos</strong> asociados a esta cuota corporativa (vía CorporatePaymentPlanId y vía LineageId).</li>
          <li>Se compara con el <strong>monto a pagar</strong> de la cuota.</li>
          <li>Se setea el estado correcto: PENDIENTE / PARCIALMENTE PAGADO / PAGADO.</li>
          <li><strong>No requiere comentario</strong> — es una operación idempotente y segura.</li>
        </ul>
      </div>
    </div>

    <!-- 🆕 Castigar saldo restante -->
    <div *ngIf="adminModal.mode === 'punish-remaining' && adminModal.plan" class="mt-4 space-y-3">
      <div class="rounded-lg border border-orange-200 bg-orange-50 p-4 text-sm text-orange-900">
        <p class="font-semibold">¿Qué va a pasar?</p>
        <ul class="mt-2 list-disc pl-5 space-y-1 text-xs">
          <li>La cuota <strong>#{{ adminModal.plan.installmentNumber }}</strong> se cierra al monto efectivamente pagado
            (<strong>{{ formatCurrencyValue(adminModal.plan.amountPaid) }}</strong>)
            y queda <strong>PAGADA</strong> + bloqueada.</li>
          <li>Se crea una <strong>nueva cuota castigada</strong> por el saldo restante
            (<strong>{{ formatCurrencyValue((adminModal.plan.amountToPay - adminModal.plan.amountPaid)) }}</strong>),
            con la misma fecha de vencimiento ({{ adminModal.plan.dueDate | date:'mediumDate' }}).</li>
          <li>Se registra un <strong>movimiento de cartera corporativo</strong> (ManualPunishment) con motivo, para trazabilidad.</li>
          <li>La nueva cuota va al <strong>final del plan</strong> (no renumera las existentes).</li>
        </ul>
      </div>
      <label class="block text-sm font-semibold text-gray-800">Motivo del castigo</label>
      <textarea rows="3" [(ngModel)]="adminModal.comment"
        placeholder="Ej: Saldo no cobrable, empresa fuera de contacto, etc."
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"></textarea>
      <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en el CorporatePortfolioMovement y en el audit trail de ambas cuotas.</p>
    </div>

    <!-- Inputs por modo -->
    <div *ngIf="adminModal.mode === 'renumber'" class="mt-4">
      <label class="block text-sm font-semibold text-gray-800">Nuevo número de cuota</label>
      <input type="number" min="1" [(ngModel)]="adminModal.newNumber"
        class="mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm" />
      <p class="mt-1 text-xs text-gray-500">No puede chocar con otra cuota activa del mismo alcance (empresa/participante + payerType).</p>
    </div>

    <div *ngIf="adminModal.mode === 'date'" class="mt-4">
      <label class="block text-sm font-semibold text-gray-800">Nueva fecha de vencimiento</label>
      <input type="date" [(ngModel)]="adminModal.newDate"
        class="mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm" />
    </div>

    <div *ngIf="adminModal.mode === 'status'" class="mt-4">
      <label class="block text-sm font-semibold text-gray-800">Nuevo estado</label>
      <select [(ngModel)]="adminModal.newStatus"
        class="mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm">
        <option value="AUTO">🔄 Auto (recalcular desde recibos)</option>
        <option value="PENDING">⏳ Pendiente</option>
        <option value="PAID">✅ Pagado</option>
        <option value="PARTIALLY_PAID">🟡 Parcialmente pagado</option>
        <option value="OVERDUE">🔴 Vencido</option>
        <option value="LINK_GENERATED">🔗 Link generado</option>
      </select>
      <div class="mt-2 rounded-lg border border-indigo-200 bg-indigo-50 p-3 text-xs text-indigo-900">
        <p class="font-semibold">¿Qué hace "Auto"?</p>
        <p class="mt-1">El backend suma los recibos activos asociados a esta cuota corporativa (vía CorporatePaymentPlanId o LineageId) y determina el estado correcto:</p>
        <ul class="mt-1 list-disc pl-5 space-y-0.5">
          <li><strong>Sin recibos</strong> → PENDIENTE</li>
          <li><strong>0 &lt; recibos &lt; monto</strong> → PARCIALMENTE PAGADO</li>
          <li><strong>recibos ≥ monto</strong> → PAGADO (y se lockea)</li>
        </ul>
      </div>
    </div>

    <div *ngIf="adminModal.mode === 'attach'" class="mt-4">
      <label class="block text-sm font-semibold text-gray-800">ID del comprobante de ingreso</label>
      <input type="number" min="1" [(ngModel)]="adminModal.attachReceiptId"
        placeholder="Ej: 5406"
        class="mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-mono" />
      <div class="mt-2 rounded-lg border border-purple-200 bg-purple-50 p-3 text-xs text-purple-900">
        <p class="font-semibold">¿Qué hace esta acción?</p>
        <ul class="mt-1 list-disc pl-5 space-y-0.5">
          <li>Reasocia el <strong>IncomeReceipt #{{ adminModal.attachReceiptId || 'X' }}</strong> a esta cuota corporativa.</li>
          <li>Una cuota puede tener N comprobantes — esta acción <strong>agrega</strong>, no reemplaza los existentes.</li>
          <li>Si el recibo estaba en otra cuota corporativa, se quita de allá y se mueve aquí.</li>
          <li>Si estaba en una cuota individual u otro acuerdo, requiere el checkbox de abajo para confirmar.</li>
          <li>Tras asociar, el status de ambas cuotas (vieja y nueva) se recalcula automáticamente.</li>
        </ul>
      </div>
      <label class="mt-3 flex cursor-pointer items-start gap-2 text-xs text-gray-700">
        <input type="checkbox" [(ngModel)]="adminModal.forceFromOtherEnrollment" class="mt-0.5">
        <span>Forzar reasignación incluso si el comprobante pertenece a OTRO acuerdo o a una cuota individual.</span>
      </label>
    </div>

    <div *ngIf="adminModal.mode === 'delete'" class="mt-4 rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">
      <p class="font-semibold">Vas a eliminar (soft delete) esta cuota corporativa.</p>
      <p class="mt-1 text-xs">La cuota queda <span class="font-mono">IsActive=false, IsDeleted=true</span>, archivada con audit trail. Si tiene recibos asociados, te va a pedir confirmación explícita.</p>
      <label class="mt-3 flex cursor-pointer items-start gap-2 text-xs">
        <input type="checkbox" [(ngModel)]="adminModal.forceIfHasReceipts" class="mt-0.5">
        <span>Forzar eliminación incluso si la cuota tiene recibos asociados (los recibos quedarán huérfanos).</span>
      </label>
    </div>

    <!-- Comentario obligatorio (solo para acciones que mutan datos) -->
    <div *ngIf="adminModal.mode && adminModal.mode !== 'menu' && adminModal.mode !== 'recalculate'" class="mt-5">
      <label class="block text-sm font-semibold text-gray-800">Comentario para audit trail (obligatorio)</label>
      <textarea [(ngModel)]="adminModal.comment" rows="3" maxlength="2000"
        placeholder="Ej: Corrección manual previa a refinanciamiento — duplicado del bug de versionado viejo."
        class="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"></textarea>
      <p class="mt-1 text-xs text-gray-500">{{ (adminModal.comment || '').length }} / 2000 (mín. 10)</p>
    </div>

    <!-- Footer -->
    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeAdminModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        {{ adminModal.mode === 'menu' ? 'Cerrar' : 'Cancelar' }}
      </button>
      <button *ngIf="adminModal.mode && adminModal.mode !== 'menu'"
        type="button" (click)="confirmAdminAction()"
        [ngClass]="(adminModal.mode === 'delete' || adminModal.mode === 'punish-remaining')
          ? 'border-rose-700 bg-rose-700 text-white hover:bg-rose-800'
          : 'border-gray-900 bg-gray-900 text-white hover:bg-gray-800'"
        class="inline-flex flex-1 items-center justify-center rounded-full border px-4 py-2 text-sm font-semibold">
        <ng-container [ngSwitch]="adminModal.mode">
          <span *ngSwitchCase="'renumber'">Renumerar</span>
          <span *ngSwitchCase="'date'">Cambiar fecha</span>
          <span *ngSwitchCase="'delete'">Eliminar cuota</span>
          <span *ngSwitchCase="'status'">Cambiar estado</span>
          <span *ngSwitchCase="'attach'">Asociar comprobante</span>
          <span *ngSwitchCase="'recalculate'">Recalcular ahora</span>
          <span *ngSwitchCase="'punish-remaining'">Castigar saldo</span>
        </ng-container>
      </button>
    </div>
  </div>
</div>

<!-- 🆕 Modal de confirmación de anulación de comprobante -->
<div *ngIf="cancelReceiptModal.open" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true"
  aria-labelledby="cancel-receipt-modal-title">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300"
    (click)="closeCancelReceiptModal()"></div>
  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 relative">
    <div
      class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-lg">
      <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div
            class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <i class="fas fa-ban text-red-600 text-xl"></i>
          </div>
          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="cancel-receipt-modal-title">
              Anular Comprobante de Ingreso
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500 leading-relaxed">
                Esta acción revierte el pago en la cuota asociada (la deja como
                <strong>Pendiente</strong> o <strong>Parcialmente pagada</strong> según corresponda)
                y registra el evento en el historial. No se puede deshacer.
              </p>
            </div>
            <div *ngIf="cancelReceiptModal.receipt" class="mt-3 bg-gray-50 rounded-lg p-3">
              <div class="text-sm text-gray-700">
                <p><strong>Comprobante:</strong> #{{ cancelReceiptModal.receipt.id }}</p>
                <p *ngIf="cancelReceiptModal.receipt.concept">
                  <strong>Concepto:</strong> {{ cancelReceiptModal.receipt.concept }}
                </p>
                <p><strong>Monto bruto:</strong>
                  {{ formatCurrencyValue(cancelReceiptModal.receipt.grossAmount,
                     cancelReceiptModal.receipt.currencySymbol, cancelReceiptModal.receipt.currencyCode) }}
                </p>
                <p *ngIf="cancelReceiptModal.receipt.transactionDate">
                  <strong>Fecha de pago:</strong>
                  {{ cancelReceiptModal.receipt.transactionDate | date:'mediumDate' }}
                </p>
              </div>
            </div>
            <div class="mt-4">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Motivo de anulación <span class="text-red-600">*</span>
              </label>
              <textarea [(ngModel)]="cancelReceiptModal.reason"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 text-sm"
                rows="3" placeholder="Especifique el motivo de la anulación (mín. 10 caracteres)..."
                maxlength="1000" [disabled]="cancelReceiptModal.submitting" required></textarea>
              <div class="mt-1 text-xs text-gray-500">
                {{ (cancelReceiptModal.reason.length || 0) }}/1000 caracteres
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <button type="button" [disabled]="cancelReceiptModal.submitting"
          class="w-full inline-flex justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          (click)="confirmCancelReceipt()">
          <i class="fas fa-ban mr-2"></i>
          {{ cancelReceiptModal.submitting ? 'Anulando...' : 'Confirmar Anulación' }}
        </button>
        <button type="button" [disabled]="cancelReceiptModal.submitting"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto transition-colors duration-200 disabled:opacity-50"
          (click)="closeCancelReceiptModal()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>